<template>
    <div :class="$style.container" id="loading" v-loading.fullscreen.lock.body="loading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.7)">

        <div style="overflow: hidden">
            <div style="float: left">
                <div style="font-size: 22px;padding: 20px;padding-top: 28px;padding-bottom: 5px;">
                    销售数据
                </div>
            </div>
            <div style="padding: 20px;padding-top: 20px;float:left;padding-bottom: 0;">
                <el-form class="year">
                    <el-form-item label="">
                        <el-date-picker v-model="form.year" type="year" placeholder="选择年" format="yyyy"
                            value-format="yyyy" style="width: 111px;margin-left: -20px" @change="fangfa">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
            </div>
            <div style="float: left;margin-top: 30px;margin-left: -9px">
                <span>年</span>
            </div>
            <div style="padding: 20px;padding-top: 20px;float: right;padding-bottom: 0;" class="people"
                v-if="role!='staff'">
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="管理辖区">
                        <el-select v-model="form.TerritoryList" placeholder="请选择" @change="xuanze">
                            <el-option v-for="item in TerritoryList" :key="item.territory_id"
                                :label="item.territory_name" :value="item.territory_id" :disabled="role=='staff'">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="box">
            <div class="zuo" style="position: relative;left: 20px">
                <img src="../../assets/images/zuo.png" alt="">
            </div>
            <div class="swiper-container" v-if="array.length>0" ref="swiperContainer">
                <div class="swiper-wrapper">

                    <div class="swiper-slide" v-for="item in array"
                        :style="{backgroundColor:item.isSelect?'#ECF3FC':'#fff',borderColor:item.isSelect?'#4A90E2':'#ededed'}">
                        <div @click="selectBack(item)">
                            <el-row style="padding:5px 10px" v-if="item.territory_code!==''">
                                <el-col :span="12"><span
                                        style="color: #4D586D;font-size: 14px">{{item.territory_name}}（{{item.territory_code}})</span>
                                </el-col>
                                <!--                                <el-col :span="12"><span style="float: right;color: #FF9901">{{item.mm}}</span></el-col>-->
                            </el-row>
                            <el-row style="padding: 10px" v-else="item.territory_code==''">
                                <el-col :span="12"><span
                                        style="color: #4D586D;font-size: 14px">{{item.territory_name}}</span></el-col>
                                <!--                                <el-col :span="12"><span style="float: right;color: #FF9901">{{item.mm}}</span></el-col>-->
                            </el-row>

                            <el-row style="padding:0 10px">
                                <el-col :span="4" v-if="item.alias!==''"><span
                                        style="border: 1px solid #FF9901;background-color: #FF9901;color: #fff;font-size: 7px;border-radius:3px;padding: 1px 3px">{{item.alias}}</span>
                                </el-col>
                                <el-col :span="4" v-else-if="item.alias==''"><span
                                        :style="{color:item.isSelect?'#ECF3FC':'#fff'}">eeee</span></el-col>
                                <!--<el-col :span="20"><span style="color: #B0B5B9;font-size: 9px">职务：SMR    入职时间：2015年7月1日</span></el-col>-->
                            </el-row>

                            <div style="padding:10px 0 0 10px">
                                <span
                                    style="color: #4D586D;font-size: 14px;display:inline-block;width: 75px">指标：</span><span
                                    style="color: #4D586D;font-size: 14px;display: inline-block;width: 51px">{{(item.targetAmount/10000).toFixed(1)}}万</span>
                                <span style="color: #4D586D;font-size: 14px;display:inline-block;width: 75px">预估：</span>
                                <div style="display: inline-block;width: 51px"><span
                                        style="color: #4D586D;font-size: 14px"
                                        v-if="item.forecast!=null">{{(item.forecastAmount/10000).toFixed(1)}}万</span>
                                    <!--<span style="background-color: #ff9901;border: 1px solid #ff9901;color: #fff;border-radius: 3px;font-size: 11px;padding: 0 5px" v-if="item.forecast==null">0</span>-->
                                </div>
                                <span
                                    style="color: #4D586D;font-size: 14px;display:inline-block;width: 60px">达成率：</span><span
                                    style="color:#AF2E24;display: inline-block;width: 25px;font-size: 14px;">{{Math.floor(parseInt(item.dcLv)*10)/10}}</span><span
                                    style="color: #fff;background-color: #9b9b9b;border-radius: 3px;padding: 0 3px;">%</span>
                            </div>

                            <div style="padding: 10px 0 0 10px">
                                <span
                                    style="color: #4D586D;font-size: 14px;display:inline-block;width: 75px">实际销售：</span><span
                                    style="color: #4A90E2;display: inline-block;width: 51px;font-size: 14px">{{(item.actualAmount/10000).toFixed(1)}}万</span>
                                <span
                                    style="color: #4D586D;font-size: 14px;display:inline-block;width: 75px">去年同期：</span><span
                                    style="color: #4A90E2;display: inline-block;width: 51px; font-size: 14px">{{(item.oldActualAmount/10000).toFixed(1)}}万</span>
                                <span
                                    style="color: #4D586D;font-size: 14px;display:inline-block;width: 60px">增长率：</span><span
                                    style="color: #4A90E2;font-size: 14px;display: inline-block;width: 25px">{{item.zzLV}}</span><span
                                    style="color: #fff;background-color: #9b9b9b;border-radius: 3px;padding: 0 3px;">%</span>
                            </div>
                        </div>
                        <span style="position: relative;left: 390px;top: -60px;" @click="dianji3(item)"
                            class="selectImg">
                            <img :src="item.isSelect?imgarr[1]:imgarr[0]" style="width: 26px" alt="">
                        </span>

                    </div>


                </div>
            </div>
            <div v-if="array.length==0"
                style="height: 150px;width: 100%;text-align: center;line-height: 150px;color:#909399;font-size: 18px">
                暂无数据</div>


            <div class="you" style="position: relative;right: 20px">
                <img src="../../assets/images/you.png" alt="">
            </div>
        </div>
        <div class="suo" style="position: relative;float: right;right: 20px;top: 10px">
            <el-checkbox v-model="checked" style="margin-right: 10px" @change="dianji4"></el-checkbox><span
                style="color: #4A90E2;font-size: 14px">选中以上所有终端辖区</span>
        </div>

        <el-row style="margin-top: 45px">
            <el-col :span="8" v-if="territoryList.length==0">
                <el-col :span="24" v-if="xiaoshou">
                    <span style="color: white">ee</span>
                </el-col>
                <el-col :span="24" v-if="alias!==''">
                    <div style="padding-left: 20px;line-height: 40px;color: #4A90E2;min-width: 1px">
                        {{territory_name}} {{territory_code}}
                        <span
                            style="background-color: #ff9901;color: #fff;font-size: 12px;border: 1px solid #ff9901;padding: 0 2px;border-radius: 3px">{{alias}}</span>
                    </div>
                </el-col>
                <el-col :span="24" v-else-if="alias==''">
                    <div style="padding-left: 20px;line-height: 40px;color: #4A90E2;min-width: 1px">
                        {{territory_name}} {{territory_code}}
                    </div>
                </el-col>

            </el-col>
            <el-col :span="8" v-else-if="territoryList.length==1">
                <el-col :span="24" v-if="alias!==''">
                    <div style="padding-left: 20px;line-height: 40px;color: #4A90E2;min-width: 1px">
                        {{territory_name}} {{territory_code}}
                        <span
                            style="background-color: #ff9901;color: #fff;font-size: 12px;border: 1px solid #ff9901;padding: 0 2px;border-radius: 3px">{{alias}}</span>
                    </div>
                </el-col>
                <el-col :span="24" v-else-if="alias==''">
                    <div style="padding-left: 20px;line-height: 40px;color: #4A90E2;min-width: 1px">
                        {{territory_name}} {{territory_code}}
                    </div>
                </el-col>
                <el-col :span="24" v-if="xiaoshou">
                    <span style="color: white">ee</span>
                </el-col>
            </el-col>
            <el-col :span="8" v-else-if="territoryList.length>1">
                <span style="padding-left: 20px;line-height: 40px;color: #4A90E2;min-width: 1px">
                    多个辖区
                </span>
            </el-col>
            <el-col :span="8" style="text-align: center">
                <div>
                    <el-radio-group v-model="radio1" @change="fangfa2">
                        <el-radio-button label="按产品" value="PRODUCT"></el-radio-button>
                        <el-radio-button label="按客户" value="INSTITUTION"></el-radio-button>
                    </el-radio-group>
                </div>
            </el-col>
            <el-col :span="8">
                <div style="float: right;padding-right: 20px">
                    <!--<el-button type="success" size="small" icon="el-icon-circle-check" @click="agree">同意</el-button>-->
                    <!--<el-button type="danger" size="small" icon="el-icon-circle-close" @click="refuse">拒绝</el-button>-->
                    <!--<el-button type="danger" size="small" icon="el-icon-s-promotion" @click=""  style="background-color:#ff9901;border-color: #ff9901">提交</el-button>-->
                    <el-button type="primary" size="small" @click="baocun">保存</el-button>
                </div>
            </el-col>
        </el-row>
        <el-row style="padding:0px 20px;background-color: #fff;height: calc(100% - 270px)" class="box1"
            v-if="radio1=='按产品'">
            <!--<el-row v-for="item in TerritoryArray" style="margin-top: 10px">-->
            <!--<span style="color:#3D9DEA;">-->
            <!--{{item.sku_name}}-->
            <!--</span>-->
            <!--<el-table-->
            <!--:data="item.tableData"-->
            <!--border-->
            <!--stripe-->
            <!--:span-method="objectSpanMethod"-->
            <!--header-cell-class-name="headerStyle2"-->
            <!--:default-sort = "{prop: 'date', order: 'descending'}"-->
            <!--style="width: 100%;margin-top: 10px;"-->
            <!--:cell-style="rowClass"-->

            <!--@selection-change="handleSelectionChange"-->
            <!--&gt;-->
            <!--<el-table-column-->
            <!--prop="sort"-->
            <!--label="序号"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<span style="color: #585757">{{scope.row.sort}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->

            <!--<el-table-column-->
            <!--prop="name"-->
            <!--label="客户"-->
            <!--sortable-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<span style="color: #585757">{{scope.row.name}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->

            <!--<el-table-column-->
            <!--prop="title"-->
            <!--label="数据"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<span style="color: #ff9901">{{scope.row.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->

            <!--<el-table-column-->
            <!--prop="m1"-->
            <!--label="1月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m1.title" :disabled="scope.row.m1.disabled" :style="{'border': (scope.row.m1.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m1.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m1.title}}</span>-->

            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m2"-->
            <!--label="2月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m2.title" :disabled="scope.row.m2.disabled" :style="{'border': (scope.row.m2.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m2.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m2.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m3"-->
            <!--label="3月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m3.title" :disabled="scope.row.m3.disabled" :style="{'border': (scope.row.m3.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m3.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m3.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m4"-->
            <!--label="4月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m4.title" :disabled="scope.row.m4.disabled" :style="{'border': (scope.row.m4.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m4.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m4.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m5"-->
            <!--label="5月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m5.title" :disabled="scope.row.m5.disabled" :style="{'border': (scope.row.m5.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m5.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m5.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m6"-->
            <!--label="6月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m6.title" :disabled="scope.row.m6.disabled" :style="{'border': (scope.row.m6.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m6.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m6.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m7"-->
            <!--label="7月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m7.title" :disabled="scope.row.m7.disabled" :style="{'border': (scope.row.m7.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m7.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m7.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m8"-->
            <!--label="8月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m8.title" :disabled="scope.row.m8.disabled" :style="{'border': (scope.row.m8.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m8.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m8.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m9"-->
            <!--label="9月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m9.title" :disabled="scope.row.m9.disabled" :style="{'border': (scope.row.m9.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m9.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m9.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m10"-->
            <!--label="10月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m10.title" :disabled="scope.row.m10.disabled" :style="{'border': (scope.row.m10.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m10.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m10.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m11"-->
            <!--label="11月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m11.title" :disabled="scope.row.m11.disabled" :style="{'border': (scope.row.m11.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m11.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m11.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m12"-->
            <!--label="12月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m12.title"  :disabled="scope.row.m12.disabled"  :style="{'border': (scope.row.m12.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m12.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m12.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->

            <!--</el-table>-->
            <!--</el-row>-->
            <el-tabs v-model="activeName" @tab-click="handleClick" v-if="TerritoryArray.length>0" class="rightTab">
                <el-tab-pane v-for="item in newAllArray" :label="item.sku_name" :name="item.sku_id" :key="item.sku_id">
                    <div style="width: 100%;height: calc(100% - 60px);overflow: hidden;overflow-y: auto">
                        <el-table :data="item.tableData" border stripe :header-cell-style="mystyle"
                            :span-method="objectSpanMethod" header-cell-class-name="headerStyleMy"
                            style="width: 100%;margin-top: 10px;" :cell-style="rowClass" @selection-change=""
                            :default-sort="{prop: 'date', order: 'descending'}">
                            <el-table-column prop="sort" label="序号" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span style="color: #585757">{{scope.row.sort}}</span>
                                </template>
                            </el-table-column>

                            <el-table-column prop="name" label="客户" sortable align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span style="color: #585757">{{scope.row.name}}</span>
                                </template>
                            </el-table-column>

                            <el-table-column prop="title" label="数据" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span style="color: #ff9901">{{scope.row.title}}</span>
                                </template>
                            </el-table-column>

                            <el-table-column prop="m1" label="1月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m1.title}}</span>
                                    <span v-else-if="scope.row.m1.disabled==true">
                                        <span v-if="scope.row.m1.title==null">-</span>
                                        <span v-else>{{scope.row.m1.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m1.disabled==false">
                                        <span v-if="scope.row.m1.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m1.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m1.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>

                                </template>
                            </el-table-column>
                            <el-table-column prop="m2" label="2月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m2.title}}</span>
                                    <span v-else-if="scope.row.m2.disabled==true">
                                        <span v-if="scope.row.m2.title==null">-</span>
                                        <span v-else>{{scope.row.m2.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m2.disabled==false">
                                        <span v-if="scope.row.m2.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m2.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m2.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m3" label="3月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m3.title}}</span>
                                    <span v-else-if="scope.row.m3.disabled==true">
                                        <span v-if="scope.row.m3.title==null">-</span>
                                        <span v-else>{{scope.row.m3.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m3.disabled==false">
                                        <span v-if="scope.row.m3.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m3.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m3.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m4" label="4月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m4.title}}</span>
                                    <span v-else-if="scope.row.m4.disabled==true">
                                        <span v-if="scope.row.m4.title==null">-</span>
                                        <span v-else>{{scope.row.m4.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m4.disabled==false">
                                        <span v-if="scope.row.m4.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m4.title">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m4.title">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m5" label="5月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m5.title}}</span>
                                    <span v-else-if="scope.row.m5.disabled==true">
                                        <span v-if="scope.row.m5.title==null">-</span>
                                        <span v-else>{{scope.row.m5.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m5.disabled==false">
                                        <span v-if="scope.row.m5.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m5.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m5.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m6" label="6月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m6.title}}</span>
                                    <span v-else-if="scope.row.m6.disabled==true">
                                        <span v-if="scope.row.m6.title==null">-</span>
                                        <span v-else>{{scope.row.m6.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m6.disabled==false">
                                        <span v-if="scope.row.m6.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m6.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m6.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m7" label="7月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m7.title}}</span>
                                    <span v-else-if="scope.row.m7.disabled==true">
                                        <span v-if="scope.row.m7.title==null">-</span>
                                        <span v-else>{{scope.row.m7.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m7.disabled==false">
                                        <span v-if="scope.row.m7.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m7.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m7.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m8" label="8月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m8.title}}</span>
                                    <span v-else-if="scope.row.m8.disabled==true">
                                        <span v-if="scope.row.m8.title==null">-</span>
                                        <span v-else>{{scope.row.m8.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m8.disabled==false">
                                        <span v-if="scope.row.m8.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m8.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m8.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m9" label="9月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m9.title}}</span>
                                    <span v-else-if="scope.row.m9.disabled==true">
                                        <span v-if="scope.row.m9.title==null">-</span>
                                        <span v-else>{{scope.row.m9.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m9.disabled==false">
                                        <span v-if="scope.row.m9.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m9.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m9.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m10" label="10月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m10.title}}</span>
                                    <span v-else-if="scope.row.m10.disabled==true">
                                        <span v-if="scope.row.m10.title==null">-</span>
                                        <span v-else>{{scope.row.m10.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m10.disabled==false">
                                        <span v-if="scope.row.m10.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m10.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m10.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m11" label="11月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m11.title}}</span>
                                    <span v-else-if="scope.row.m11.disabled==true">
                                        <span v-if="scope.row.m11.title==null">-</span>
                                        <span v-else>{{scope.row.m11.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m11.disabled==false">
                                        <span v-if="scope.row.m11.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m11.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m11.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m12" label="12月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m12.title}}</span>
                                    <span v-else-if="scope.row.m12.disabled==true">
                                        <span v-if="scope.row.m12.title==null">-</span>
                                        <span v-else>{{scope.row.m12.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m12.disabled==false">
                                        <span v-if="scope.row.m12.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m12.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m12.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>

                        </el-table>

                        <el-col style="margin-top: 10px">
                            <span style="color:#4D586D;font-size: 14px">
                                以上为产品的指标数量、预估数量和实际数量
                            </span>
                        </el-col>
                        <el-col>
                            <el-table :data="NewtableData" :span-method="arraySpanMethod" border :show-header=false
                                style="width: 100%;margin-top: 10px;" :cell-style="rowClass" @selection-change="">
                                <el-table-column prop="name" sortable align="center" minWidth="10px">
                                    <template slot-scope="scope">
                                        <span style="color: #4A90E2">{{scope.row.name}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="title" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span style="color: #4A90E2">{{scope.row.title}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul==0">-</span>
                                            <span v-else>{{scope.row.restul.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul==0">-</span>
                                            <span v-else>{{scope.row.restul}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul2" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul2==0">-</span>
                                            <span v-else>{{scope.row.restul2.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul2==0">-</span>
                                            <span v-else>{{scope.row.restul2}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul3" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul3==0">-</span>
                                            <span v-else>{{scope.row.restul3.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul3==0">-</span>
                                            <span v-else>{{scope.row.restul3}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul4" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul4==0">-</span>
                                            <span v-else>{{scope.row.restul4.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul4==0">-</span>
                                            <span v-else>{{scope.row.restul4}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul5" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul5==0">-</span>
                                            <span v-else>{{scope.row.restul5.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul5==0">-</span>
                                            <span v-else>{{scope.row.restul5}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul6" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul6==0">-</span>
                                            <span v-else>{{scope.row.restul6.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul6==0">-</span>
                                            <span v-else>{{scope.row.restul6}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul7" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul7==0">-</span>
                                            <span v-else>{{scope.row.restul7.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul7==0">-</span>
                                            <span v-else>{{scope.row.restul7}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul8" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul8==0">-</span>
                                            <span v-else>{{scope.row.restul8.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul8==0">-</span>
                                            <span v-else>{{scope.row.restul8}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul9" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul9==0">-</span>
                                            <span v-else>{{scope.row.restul9.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul9==0">-</span>
                                            <span v-else>{{scope.row.restul9}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul10" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul10==0">-</span>
                                            <span v-else>{{scope.row.restul10.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul10==0">-</span>
                                            <span v-else>{{scope.row.restul10}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul11" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul11==0">-</span>
                                            <span v-else>{{scope.row.restul11.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul11==0">-</span>
                                            <span v-else>{{scope.row.restul11}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul12" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul12==0">-</span>
                                            <span v-else>{{scope.row.restul12.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul12==0">-</span>
                                            <span v-else>{{scope.row.restul12}}</span>
                                        </span>
                                    </template>
                                </el-table-column>

                            </el-table>
                        </el-col>

                    </div>
                    <el-col style="margin-top: 10px">
                        <div v-if="territoryArray.length==1">
                            <span
                                style="border: 1px solid #ff9901;font-size: 14px;color: #fff;background-color: #ff9901;border-radius: 3px;padding: 0px 5px">{{territory_name}}
                                {{territory_code}} </span>
                            <span style="color:#4A90E2;font-size: 14px;margin-left: 10px">{{form.year}}年{{mm}} 金额合计(万元)
                            </span>
                        </div>
                        <div v-if="territoryArray.length>1">
                            <span
                                style="border: 1px solid #ff9901;font-size: 14px;color: #fff;background-color: #ff9901;border-radius: 3px;padding: 0px 5px">多个终端辖区</span>
                            <span style="color:#4A90E2;font-size: 14px;margin-left: 10px">{{form.year}}年{{mm}} 金额合计(万元)
                            </span>
                        </div>
                        <div style="color: #4D586D;padding-bottom: 10px;margin-top: 10px;">
                            <span>指标：</span><span>{{targetAmount.toFixed(1)}}</span>
                            <span style="margin-left: 30px">预估：</span><span
                                style="color: #AF2E24;margin-left: 10px">{{forecastAmount.toFixed(1)}}</span>
                            <span style="margin-left: 30px">达成率：</span><span
                                style="color:#AF2E24;margin-left: 10px">{{dcLv}}</span><span
                                style="color: #fff;background-color: #9b9b9b;border-radius: 3px;padding: 0 3px;margin-left: 5px">%</span>
                            <span style="margin-left: 30px">实际销售：</span><span
                                style="color: #4A90E2;margin-left: 10px">{{actualAmount.toFixed(1)}}</span>
                            <span style="margin-left: 30px">去年同期：</span><span
                                style="color: #4A90E2;margin-left: 10px">{{oldActualAmount.toFixed(1)}}</span>
                            <span style="margin-left: 30px">增长率：</span><span
                                style="color: #4A90E2;margin-left: 10px">{{(zzLV)}}</span><span
                                style="color: #fff;background-color: #9b9b9b;border-radius: 3px;padding: 0 3px;margin-left: 5px">%</span>
                        </div>
                    </el-col>


                </el-tab-pane>
            </el-tabs>
            <el-col style="text-align: center;margin-top:100px" v-if="TerritoryArray.length==0">
                <img src="../../assets/images/691C8AAA4F3F3242DF42BB05FCAFB165.png" alt="">
            </el-col>

        </el-row>

        <el-row style="padding:0px 20px;background-color: #fff;height: calc(100% - 270px)" class="box1"
            v-if="radio1=='按客户'">
            <!--<el-row v-for="item in TerritoryArray" style="margin-top: 10px">-->

            <!--<span style="color:#3D9DEA;">-->
            <!--{{item.sku_name}}-->
            <!--</span>-->
            <!--<el-table-->
            <!--:data="item.tableData"-->
            <!--border-->
            <!--stripe-->
            <!--:span-method="objectSpanMethod"-->
            <!--header-cell-class-name="headerStyle2"-->
            <!--:default-sort = "{prop: 'date', order: 'descending'}"-->
            <!--style="width: 100%;margin-top: 10px"-->
            <!--:cell-style="rowClass"-->
            <!--@selection-change="handleSelectionChange"-->
            <!--&gt;-->
            <!--<el-table-column-->
            <!--prop="sort"-->
            <!--label="序号"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<span style="color: #585757">{{scope.row.sort}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->

            <!--<el-table-column-->
            <!--prop="name"-->
            <!--label="产品"-->
            <!--sortable-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<span style="color: #585757">{{scope.row.name}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->

            <!--<el-table-column-->
            <!--prop="title"-->
            <!--label="数据"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<span style="color: #ff9901">{{scope.row.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->

            <!--<el-table-column-->
            <!--prop="m1"-->
            <!--label="1月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m1.title" :disabled="scope.row.m1.disabled" :style="{'border': (scope.row.m1.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m1.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m1.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m2"-->
            <!--label="2月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m2.title" :disabled="scope.row.m2.disabled" :style="{'border': (scope.row.m2.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m2.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m2.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m3"-->
            <!--label="3月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m3.title" :disabled="scope.row.m3.disabled" :style="{'border': (scope.row.m3.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m3.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m3.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m4"-->
            <!--label="4月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m4.title" :disabled="scope.row.m4.disabled" :style="{'border': (scope.row.m4.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m4.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m4.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m5"-->
            <!--label="5月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m5.title" :disabled="scope.row.m5.disabled" :style="{'border': (scope.row.m5.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m5.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m5.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m6"-->
            <!--label="6月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m6.title" :disabled="scope.row.m6.disabled" :style="{'border': (scope.row.m6.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m6.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m6.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m7"-->
            <!--label="7月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m7.title" :disabled="scope.row.m7.disabled" :style="{'border': (scope.row.m7.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m7.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m7.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m8"-->
            <!--label="8月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m8.title" :disabled="scope.row.m8.disabled" :style="{'border': (scope.row.m8.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m8.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m8.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m9"-->
            <!--label="9月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m9.title" :disabled="scope.row.m9.disabled" :style="{'border': (scope.row.m9.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m9.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m9.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m10"-->
            <!--label="10月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m10.title" :disabled="scope.row.m10.disabled" :style="{'border': (scope.row.m10.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m10.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m10.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m11"-->
            <!--label="11月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m11.title" :disabled="scope.row.m11.disabled" :style="{'border': (scope.row.m11.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m11.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m11.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="m12"-->
            <!--label="12月"-->
            <!--align="center"-->
            <!--minWidth="5px">-->
            <!--<template slot-scope="scope">-->
            <!--<input type="number" class="inputStyle" placeholder="未填写" min="0" v-model="scope.row.m12.title" :disabled="scope.row.m12.disabled" :style="{'border': (scope.row.m12.disabled==true ? 'none':'1px solid #ededed'),'backgroundColor':(scope.row.m12.disabled==true ? '#f9f9f9':'#fff')}" onkeyup="value = value.replace(/[^0-9]/g,'')"  v-if="scope.row.title!=='达成率' ">-->
            <!--<span v-else>{{scope.row.m12.title}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->

            <!--</el-table>-->
            <!--</el-row>-->
            <el-tabs v-model="activeName" @tab-click="handleClick" v-if="TerritoryArray.length>0" class="rightTab">
                <el-tab-pane v-for="item in newAllArray"
                    :label="item.institution_name||item.store_name||item.distributor_name"
                    :name="item.institution_id||item.store_id||item.distributor_id"
                    :key="item.institution_id||item.store_id||item.distributor_id">
                    <div style="width: 100%;height: calc(100% - 60px);overflow: hidden;overflow-y: auto">
                        <el-table :data="item.tableData" border stripe :header-cell-style="mystyle"
                            :span-method="objectSpanMethod" header-cell-class-name="headerStyleMy"
                            style="width: 100%;margin-top: 10px;" :cell-style="rowClass" @selection-change=""
                            :default-sort="{prop: 'date', order: 'descending'}">
                            <el-table-column prop="sort" label="序号" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span style="color: #585757">{{scope.row.sort}}</span>
                                </template>
                            </el-table-column>

                            <el-table-column prop="name" label="产品" sortable align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span style="color: #585757">{{scope.row.name}}</span>
                                </template>
                            </el-table-column>

                            <el-table-column prop="title" label="数据" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span style="color: #ff9901">{{scope.row.title}}</span>
                                </template>
                            </el-table-column>

                            <el-table-column prop="m1" label="1月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m1.title}}</span>
                                    <span v-else-if="scope.row.m1.disabled==true">
                                        <span v-if="scope.row.m1.title==null">-</span>
                                        <span v-else>{{scope.row.m1.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m1.disabled==false">
                                        <span v-if="scope.row.m1.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m1.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m1.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>

                                </template>
                            </el-table-column>
                            <el-table-column prop="m2" label="2月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m2.title}}</span>
                                    <span v-else-if="scope.row.m2.disabled==true">
                                        <span v-if="scope.row.m2.title==null">-</span>
                                        <span v-else>{{scope.row.m2.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m2.disabled==false">
                                        <span v-if="scope.row.m2.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m2.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m2.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m3" label="3月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m3.title}}</span>
                                    <span v-else-if="scope.row.m3.disabled==true">
                                        <span v-if="scope.row.m3.title==null">-</span>
                                        <span v-else>{{scope.row.m3.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m3.disabled==false">
                                        <span v-if="scope.row.m3.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m3.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m3.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m4" label="4月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m4.title}}</span>
                                    <span v-else-if="scope.row.m4.disabled==true">
                                        <span v-if="scope.row.m4.title==null">-</span>
                                        <span v-else>{{scope.row.m4.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m4.disabled==false">
                                        <span v-if="scope.row.m4.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m4.title">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m4.title">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m5" label="5月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m5.title}}</span>
                                    <span v-else-if="scope.row.m5.disabled==true">
                                        <span v-if="scope.row.m5.title==null">-</span>
                                        <span v-else>{{scope.row.m5.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m5.disabled==false">
                                        <span v-if="scope.row.m5.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m5.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m5.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m6" label="6月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m6.title}}</span>
                                    <span v-else-if="scope.row.m6.disabled==true">
                                        <span v-if="scope.row.m6.title==null">-</span>
                                        <span v-else>{{scope.row.m6.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m6.disabled==false">
                                        <span v-if="scope.row.m6.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m6.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m6.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m7" label="7月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m7.title}}</span>
                                    <span v-else-if="scope.row.m7.disabled==true">
                                        <span v-if="scope.row.m7.title==null">-</span>
                                        <span v-else>{{scope.row.m7.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m7.disabled==false">
                                        <span v-if="scope.row.m7.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m7.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m7.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m8" label="8月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m8.title}}</span>
                                    <span v-else-if="scope.row.m8.disabled==true">
                                        <span v-if="scope.row.m8.title==null">-</span>
                                        <span v-else>{{scope.row.m8.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m8.disabled==false">
                                        <span v-if="scope.row.m8.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m8.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m8.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m9" label="9月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m9.title}}</span>
                                    <span v-else-if="scope.row.m9.disabled==true">
                                        <span v-if="scope.row.m9.title==null">-</span>
                                        <span v-else>{{scope.row.m9.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m9.disabled==false">
                                        <span v-if="scope.row.m9.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m9.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m9.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m10" label="10月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m10.title}}</span>
                                    <span v-else-if="scope.row.m10.disabled==true">
                                        <span v-if="scope.row.m10.title==null">-</span>
                                        <span v-else>{{scope.row.m10.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m10.disabled==false">
                                        <span v-if="scope.row.m10.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m10.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m10.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m11" label="11月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m11.title}}</span>
                                    <span v-else-if="scope.row.m11.disabled==true">
                                        <span v-if="scope.row.m11.title==null">-</span>
                                        <span v-else>{{scope.row.m11.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m11.disabled==false">
                                        <span v-if="scope.row.m11.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m11.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m11.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m12" label="12月" align="center" minWidth="5px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.title=='达成率'">{{scope.row.m12.title}}</span>
                                    <span v-else-if="scope.row.m12.disabled==true">
                                        <span v-if="scope.row.m12.title==null">-</span>
                                        <span v-else>{{scope.row.m12.title}}</span>
                                    </span>
                                    <span v-else-if="scope.row.m12.disabled==false">
                                        <span v-if="scope.row.m12.title==null">
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m12.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                        <span v-else>
                                            <input type="number" class="inputStyle" placeholder="请填写" min="0"
                                                v-model="scope.row.m12.title"
                                                onkeyup="value = value.replace(/[^0-9]/g,'')">
                                        </span>
                                    </span>
                                </template>
                            </el-table-column>

                        </el-table>
                        <el-col style="margin-top: 10px">
                            <span>
                                以上为产品的指标数量、预估数量和实际数量
                            </span>
                        </el-col>
                        <el-col>
                            <el-table :data="NewtableData" :span-method="arraySpanMethod" border :show-header=false
                                style="width: 100%;margin-top: 10px;" :cell-style="rowClass" @selection-change="">
                                <el-table-column prop="name" sortable align="center" minWidth="10px">
                                    <template slot-scope="scope">
                                        <span style="color: #4A90E2">{{scope.row.name}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="title" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span style="color: #4A90E2">{{scope.row.title}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul==0">-</span>
                                            <span v-else>{{scope.row.restul.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul==0">-</span>
                                            <span v-else>{{scope.row.restul}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul2" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul2==0">-</span>
                                            <span v-else>{{scope.row.restul2.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul2==0">-</span>
                                            <span v-else>{{scope.row.restul2}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul3" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul3==0">-</span>
                                            <span v-else>{{scope.row.restul3.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul3==0">-</span>
                                            <span v-else>{{scope.row.restul3}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul4" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul4==0">-</span>
                                            <span v-else>{{scope.row.restul4.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul4==0">-</span>
                                            <span v-else>{{scope.row.restul4}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul5" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul5==0">-</span>
                                            <span v-else>{{scope.row.restul5.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul5==0">-</span>
                                            <span v-else>{{scope.row.restul5}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul6" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul6==0">-</span>
                                            <span v-else>{{scope.row.restul6.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul6==0">-</span>
                                            <span v-else>{{scope.row.restul6}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul7" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul7==0">-</span>
                                            <span v-else>{{scope.row.restul7.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul7==0">-</span>
                                            <span v-else>{{scope.row.restul7}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul8" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul8==0">-</span>
                                            <span v-else>{{scope.row.restul8.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul8==0">-</span>
                                            <span v-else>{{scope.row.restul8}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul9" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul9==0">-</span>
                                            <span v-else>{{scope.row.restul9.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul9==0">-</span>
                                            <span v-else>{{scope.row.restul9}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul10" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul10==0">-</span>
                                            <span v-else>{{scope.row.restul10.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul10==0">-</span>
                                            <span v-else>{{scope.row.restul10}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul11" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul11==0">-</span>
                                            <span v-else>{{scope.row.restul11.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul11==0">-</span>
                                            <span v-else>{{scope.row.restul11}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="restul12" align="center" minWidth="5px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.title=='达成率'">
                                            <span v-if="scope.row.restul12==0">-</span>
                                            <span v-else>{{scope.row.restul12.toFixed(1)}}%</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="scope.row.restul12==0">-</span>
                                            <span v-else>{{scope.row.restul12}}</span>
                                        </span>
                                    </template>
                                </el-table-column>

                            </el-table>
                        </el-col>
                    </div>
                    <el-col style="margin-top: 10px">
                        <div v-if="territoryArray.length==1">
                            <span
                                style="border: 1px solid #ff9901;font-size: 14px;color: #fff;background-color: #ff9901;border-radius: 3px;padding: 0px 5px">{{territory_name}}
                                {{territory_code}} </span>
                            <span style="color:#4A90E2;font-size: 14px;margin-left: 10px">{{form.year}}年{{mm}} 金额合计(万元)
                            </span>
                        </div>
                        <div v-if="territoryArray.length>1">
                            <span
                                style="border: 1px solid #ff9901;font-size: 14px;color: #fff;background-color: #ff9901;border-radius: 3px;padding: 0px 5px">多个终端辖区</span>
                            <span style="color:#4A90E2;font-size: 14px;margin-left: 10px">{{form.year}}年{{mm}} 金额合计(万元)
                            </span>
                        </div>
                        <div style="color: #4D586D;padding-bottom: 10px;margin-top: 10px;">
                            <span>指标：</span><span>{{targetAmount.toFixed(1)}}</span>
                            <span style="margin-left: 30px">预估：</span><span
                                style="color: #AF2E24;margin-left: 10px">{{forecastAmount.toFixed(1)}}</span>
                            <span style="margin-left: 30px">达成率：</span><span
                                style="color:#AF2E24;margin-left: 10px">{{dcLv}}</span><span
                                style="color: #fff;background-color: #9b9b9b;border-radius: 3px;padding: 0 3px;margin-left: 5px">%</span>
                            <span style="margin-left: 30px">实际销售：</span><span
                                style="color: #4A90E2;margin-left: 10px">{{actualAmount.toFixed(1)}}</span>
                            <span style="margin-left: 30px">去年同期：</span><span
                                style="color: #4A90E2;margin-left: 10px">{{oldActualAmount.toFixed(1)}}</span>
                            <span style="margin-left: 30px">增长率：</span><span
                                style="color: #4A90E2;margin-left: 10px">{{(zzLV)}}</span><span
                                style="color: #fff;background-color: #9b9b9b;border-radius: 3px;padding: 0 3px;margin-left: 5px">%</span>
                        </div>
                    </el-col>
                </el-tab-pane>

            </el-tabs>
            <el-col style="text-align: center;margin-top:100px" v-if="TerritoryArray.length==0">
                <img src="../../assets/images/691C8AAA4F3F3242DF42BB05FCAFB165.png" alt="">
            </el-col>
        </el-row>

    </div>
</template>

<script>
    import Swiper from 'swiper'
    import http from '../../APIService/http'
    import ElForm from "../../../node_modules/element-ui/packages/form/src/form.vue";
    import { MessageBox, Message } from 'element-ui';
    export default {
        components: { ElForm },
        data() {
            return {
                radio1: '按产品',
                role: '',
                loading: false,
                newAllArray: [],
                form: {
                    year: '',
                    TerritoryList: '',
                },
                TerritoryList: [],
                array: [],
                territoryArray: [],
                imgarr: [require('../../assets/images/weixuan.png'), require('../../assets/images/gouxuan.png')],
                territory_name: '',
                territory_code: '',
                alias: "",
                xiaoshou: true,
                TerritoryArray: [],
                key: 'PRODUCT',
                time: '',
                activeName: '',
                territoryList: [],
                mm: '',
                targetAmount: 0,
                forecastAmount: 0,
                dcLv: 0,
                actualAmount: 0,
                oldActualAmount: 0,
                zzLV: 0,
                tab: 0,
                NewtableData: [

                ],
                page: 0,


            }
        },
        created() {



            this.role = this.$store.getters.getUser.role
            this.form.TerritoryList = this.$route.query.user_id

            if (this.form.TerritoryList == null) {
                this.form.TerritoryList = ''
            }
            if (this.form.TerritoryList == undefined) {
                this.form.TerritoryList = ''
            }
            this.form.year = new Date().Format('yyyy')


            let mm = ""
            let dd = ""
            if (parseInt(new Date().getMonth() + 1) < 10) {
                mm += "0"
            }
            mm += (new Date().getMonth() + 1).toString()

            if (parseInt(new Date().getDate()) < 10) {
                dd += "0"
            }
            dd += (new Date().getDate()).toString()
            this.time = new Date().getFullYear() + '-' + mm + '-' + dd
            //console.log(this.time)
            this.getTerritoryList()
        },

        methods: {
            handleEvent() {
                this.page = 1
                let clear = null
                this.$nextTick(() => {
                    setTimeout(() => {
                        let rightTabs = document.querySelector('.rightTab .el-tabs__nav-next')
                        let rightTab = document.querySelector('.rightTab')
                        console.log(rightTabs, rightTab, 1714)
                        rightTabs.addEventListener('click', () => {
                            clear || clearTimeout(clear)
                            clear = setTimeout(() => {
                                debugger;
                                this.newAllArray = [... this.newAllArray, ...this.TerritoryArray.slice(this.page * 50, (this.page + 1) * 50)]
                                debugger
                                this.page += 1
                            }, 200)

                        })
                    }, 1000)

                })




            },
            MySum() {
                this.NewtableData = []
                let target = []
                let forecast = []
                let actual = []
                let dcl = []
                // console.log(this.TerritoryArray[this.tab])
                let objArray = this.TerritoryArray[this.tab].tableData

                for (let j = 0; j < objArray.length; j++) {//循环 objArray数组
                    if (objArray[j].title == '指标') {
                        target.push(objArray[j])
                    }
                    else if (objArray[j].title == '预估') {
                        forecast.push(objArray[j])
                    }
                    else if (objArray[j].title == '实际') {
                        actual.push(objArray[j])
                    }
                    else if (objArray[j].title == '达成率') {
                        dcl.push(objArray[j])
                    }
                }


                let targetT = {
                    restul: 0,
                    restul2: 0,
                    restul3: 0,
                    restul4: 0,
                    restul5: 0,
                    restul6: 0,
                    restul7: 0,
                    restul8: 0,
                    restul9: 0,
                    restul10: 0,
                    restul11: 0,
                    restul12: 0,
                    title: '',
                    name: ''

                }
                let forecastF = {
                    restul: 0,
                    restul2: 0,
                    restul3: 0,
                    restul4: 0,
                    restul5: 0,
                    restul6: 0,
                    restul7: 0,
                    restul8: 0,
                    restul9: 0,
                    restul10: 0,
                    restul11: 0,
                    restul12: 0,
                    title: '',
                    name: ''

                }
                let actualA = {
                    restul: 0,
                    restul2: 0,
                    restul3: 0,
                    restul4: 0,
                    restul5: 0,
                    restul6: 0,
                    restul7: 0,
                    restul8: 0,
                    restul9: 0,
                    restul10: 0,
                    restul11: 0,
                    restul12: 0,
                    title: '',
                    name: ''

                }
                let dclD = {
                    restul: 0,
                    restul2: 0,
                    restul3: 0,
                    restul4: 0,
                    restul5: 0,
                    restul6: 0,
                    restul7: 0,
                    restul8: 0,
                    restul9: 0,
                    restul10: 0,
                    restul11: 0,
                    restul12: 0,
                    title: '',
                    name: ''

                }
                for (let i = 0; i < target.length; i++) {
                    let objT = target[i]
                    targetT.title = objT.title
                    targetT.name = '合计(数量)'
                    targetT.restul += parseInt(objT.m1.title || 0)
                    targetT.restul2 += parseInt(objT.m2.title || 0)
                    targetT.restul3 += parseInt(objT.m3.title || 0)
                    targetT.restul4 += parseInt(objT.m4.title || 0)
                    targetT.restul5 += parseInt(objT.m5.title || 0)
                    targetT.restul6 += parseInt(objT.m6.title || 0)
                    targetT.restul7 += parseInt(objT.m7.title || 0)
                    targetT.restul8 += parseInt(objT.m8.title || 0)
                    targetT.restul9 += parseInt(objT.m9.title || 0)
                    targetT.restul10 += parseInt(objT.m10.title || 0)
                    targetT.restul11 += parseInt(objT.m11.title || 0)
                    targetT.restul12 += parseInt(objT.m12.title || 0)
                }
                for (let i = 0; i < forecast.length; i++) {
                    let objF = forecast[i]
                    forecastF.title = objF.title
                    forecastF.name = '合计(数量)'
                    forecastF.restul += parseInt(objF.m1.title || 0)
                    forecastF.restul2 += parseInt(objF.m2.title || 0)
                    forecastF.restul3 += parseInt(objF.m3.title || 0)
                    forecastF.restul4 += parseInt(objF.m4.title || 0)
                    forecastF.restul5 += parseInt(objF.m5.title || 0)
                    forecastF.restul6 += parseInt(objF.m6.title || 0)
                    forecastF.restul7 += parseInt(objF.m7.title || 0)
                    forecastF.restul8 += parseInt(objF.m8.title || 0)
                    forecastF.restul9 += parseInt(objF.m9.title || 0)
                    forecastF.restul10 += parseInt(objF.m10.title || 0)
                    forecastF.restul11 += parseInt(objF.m11.title || 0)
                    forecastF.restul12 += parseInt(objF.m12.title || 0)
                }
                for (let i = 0; i < actual.length; i++) {
                    let objA = actual[i]
                    actualA.title = objA.title
                    actualA.name = '合计(数量)'
                    actualA.restul += parseInt(objA.m1.title || 0)
                    actualA.restul2 += parseInt(objA.m2.title || 0)
                    actualA.restul3 += parseInt(objA.m3.title || 0)
                    actualA.restul4 += parseInt(objA.m4.title || 0)
                    actualA.restul5 += parseInt(objA.m5.title || 0)
                    actualA.restul6 += parseInt(objA.m6.title || 0)
                    actualA.restul7 += parseInt(objA.m7.title || 0)
                    actualA.restul8 += parseInt(objA.m8.title || 0)
                    actualA.restul9 += parseInt(objA.m9.title || 0)
                    actualA.restul10 += parseInt(objA.m10.title || 0)
                    actualA.restul11 += parseInt(objA.m11.title || 0)
                    actualA.restul12 += parseInt(objA.m12.title || 0)
                }

                for (let i = 0; i < dcl.length; i++) {
                    let objD = dcl[i]
                    dclD.title = objD.title
                    dclD.name = '合计(数量)'
                    dclD.restul += this.fangfa3(parseInt(objD.m1.title.split('%')[0]))
                    dclD.restul2 += this.fangfa3(parseInt(objD.m2.title.split('%')[0]))
                    dclD.restul3 += this.fangfa3(parseInt(objD.m3.title.split('%')[0]))
                    dclD.restul4 += this.fangfa3(parseInt(objD.m4.title.split('%')[0]))
                    dclD.restul5 += this.fangfa3(parseInt(objD.m5.title.split('%')[0]))
                    dclD.restul6 += this.fangfa3(parseInt(objD.m6.title.split('%')[0]))
                    dclD.restul7 += this.fangfa3(parseInt(objD.m7.title.split('%')[0]))
                    dclD.restul8 += this.fangfa3(parseInt(objD.m8.title.split('%')[0]))
                    dclD.restul9 += this.fangfa3(parseInt(objD.m9.title.split('%')[0]))
                    dclD.restul10 += this.fangfa3(parseInt(objD.m10.title.split('%')[0]))
                    dclD.restul11 += this.fangfa3(parseInt(objD.m11.title.split('%')[0]))
                    dclD.restul12 += this.fangfa3(parseInt(objD.m12.title.split('%')[0]))
                }
                this.NewtableData = [targetT, forecastF, actualA, dclD]

                console.log('11111', this.NewtableData)
            },
            async handleClick(tab, event) {
                this.tab = tab.index
                //console.log(tab, event);
                this.NewtableData = []
                let target = []
                let forecast = []
                let actual = []
                let dcl = []
                let data = {
                    territoryIds: this.territoryArray,
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    year: this.form.year,
                    user_id: this.$store.getters.getUser.user_id,
                    obj: this.TerritoryArray[this.tab],
                    data_type: this.key
                }
                this.TerritoryArray[this.tab].tableData = []
                // console.log(this.TerritoryArray[this.tab])
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                await http.post('/wapi/sales/getSalesListBySkuId', data).then(res => {
                    if (res.success) {
                        let array = res.data.array[0]
                        let item = this.TerritoryArray[this.tab]
                        item.tableData = []
                        
                        for (let j = 0; j < array.length; j++) {
                            let o = array[j]
                            //item.sku_name = this.key == 'PRODUCT' ? o.sku_name : o.name

                            let target = {
                                title: '指标',
                                sort: parseInt(j) + 1,
                                name: this.key == 'PRODUCT' ? o.name : o.sku_name,
                                type: o.type,
                                key_id: o.key_id,
                                product_id: o.product_id,
                                sku_id: o.sku_id,
                                id: o.id,

                                m1: { title: o.m1_target_quantity, disabled: this.panduan(res.data.targetArray[0]), amount: o.m1_target_amount },
                                m2: { title: o.m2_target_quantity, disabled: this.panduan(res.data.targetArray[1]), amount: o.m2_target_amount },
                                m3: { title: o.m3_target_quantity, disabled: this.panduan(res.data.targetArray[2]), amount: o.m3_target_amount },
                                m4: { title: o.m4_target_quantity, disabled: this.panduan(res.data.targetArray[3]), amount: o.m4_target_amount },
                                m5: { title: o.m5_target_quantity, disabled: this.panduan(res.data.targetArray[4]), amount: o.m5_target_amount },
                                m6: { title: o.m6_target_quantity, disabled: this.panduan(res.data.targetArray[5]), amount: o.m6_target_amount },
                                m7: { title: o.m7_target_quantity, disabled: this.panduan(res.data.targetArray[6]), amount: o.m7_target_amount },
                                m8: { title: o.m8_target_quantity, disabled: this.panduan(res.data.targetArray[7]), amount: o.m8_target_amount },
                                m9: { title: o.m9_target_quantity, disabled: this.panduan(res.data.targetArray[8]), amount: o.m9_target_amount },
                                m10: { title: o.m10_target_quantity, disabled: this.panduan(res.data.targetArray[9]), amount: o.m10_target_amount },
                                m11: { title: o.m11_target_quantity, disabled: this.panduan(res.data.targetArray[10]), amount: o.m11_target_amount },
                                m12: { title: o.m12_target_quantity, disabled: this.panduan(res.data.targetArray[11]), amount: o.m12_target_amount },




                            }
                            let forecast = {
                                title: '预估',
                                sort: parseInt(j) + 1,
                                name: this.key == 'PRODUCT' ? o.name : o.sku_name,
                                type: o.type,
                                key_id: o.key_id,
                                product_id: o.product_id,
                                sku_id: o.sku_id,
                                id: o.id,

                                m1: { title: o.m1_forecast_quantity, disabled: this.panduan(res.data.forecastArray[0]), amount: o.m1_forecast_amount },
                                m2: { title: o.m2_forecast_quantity, disabled: this.panduan(res.data.forecastArray[1]), amount: o.m2_forecast_amount },
                                m3: { title: o.m3_forecast_quantity, disabled: this.panduan(res.data.forecastArray[2]), amount: o.m3_forecast_amount },
                                m4: { title: o.m4_forecast_quantity, disabled: this.panduan(res.data.forecastArray[3]), amount: o.m4_forecast_amount },
                                m5: { title: o.m5_forecast_quantity, disabled: this.panduan(res.data.forecastArray[4]), amount: o.m5_forecast_amount },
                                m6: { title: o.m6_forecast_quantity, disabled: this.panduan(res.data.forecastArray[5]), amount: o.m6_forecast_amount },
                                m7: { title: o.m7_forecast_quantity, disabled: this.panduan(res.data.forecastArray[6]), amount: o.m7_forecast_amount },
                                m8: { title: o.m8_forecast_quantity, disabled: this.panduan(res.data.forecastArray[7]), amount: o.m8_forecast_amount },
                                m9: { title: o.m9_forecast_quantity, disabled: this.panduan(res.data.forecastArray[8]), amount: o.m9_forecast_amount },
                                m10: { title: o.m10_forecast_quantity, disabled: this.panduan(res.data.forecastArray[9]), amount: o.m10_forecast_amount },
                                m11: { title: o.m11_forecast_quantity, disabled: this.panduan(res.data.forecastArray[10]), amount: o.m11_forecast_amount },
                                m12: { title: o.m12_forecast_quantity, disabled: this.panduan(res.data.forecastArray[11]), amount: o.m12_forecast_amount },
                            }
                            let actual = {
                                title: '实际',
                                sort: parseInt(j) + 1,
                                name: this.key == 'PRODUCT' ? o.name : o.sku_name,
                                type: o.type,
                                key_id: o.key_id,
                                product_id: o.product_id,
                                sku_id: o.sku_id,
                                id: o.id,

                                m1: { title: o.m1_actual_quantity, disabled: this.panduan(res.data.actualArray[0]), amount: o.m1_actual_amount },
                                m2: { title: o.m2_actual_quantity, disabled: this.panduan(res.data.actualArray[1]), amount: o.m2_actual_amount },
                                m3: { title: o.m3_actual_quantity, disabled: this.panduan(res.data.actualArray[2]), amount: o.m3_actual_amount },
                                m4: { title: o.m4_actual_quantity, disabled: this.panduan(res.data.actualArray[3]), amount: o.m4_actual_amount },
                                m5: { title: o.m5_actual_quantity, disabled: this.panduan(res.data.actualArray[4]), amount: o.m5_actual_amount },
                                m6: { title: o.m6_actual_quantity, disabled: this.panduan(res.data.actualArray[5]), amount: o.m6_actual_amount },
                                m7: { title: o.m7_actual_quantity, disabled: this.panduan(res.data.actualArray[6]), amount: o.m7_actual_amount },
                                m8: { title: o.m8_actual_quantity, disabled: this.panduan(res.data.actualArray[7]), amount: o.m8_actual_amount },
                                m9: { title: o.m9_actual_quantity, disabled: this.panduan(res.data.actualArray[8]), amount: o.m9_actual_amount },
                                m10: { title: o.m10_actual_quantity, disabled: this.panduan(res.data.actualArray[9]), amount: o.m10_actual_amount },
                                m11: { title: o.m11_actual_quantity, disabled: this.panduan(res.data.actualArray[10]), amount: o.m11_actual_amount },
                                m12: { title: o.m12_actual_quantity, disabled: this.panduan(res.data.actualArray[11]), amount: o.m12_actual_amount },
                            }
                            let dcl = {
                                title: '达成率',
                                sort: parseInt(j) + 1,
                                name: this.key == 'PRODUCT' ? o.name : o.sku_name,
                                type: o.type,
                                key_id: o.key_id,
                                product_id: o.product_id,
                                sku_id: o.sku_id,

                                m1: { title: this.SumSuanFa((actual.m1.title / forecast.m1.title * 100).toFixed(1)) + "%" },
                                m2: { title: this.SumSuanFa((actual.m2.title / forecast.m2.title * 100).toFixed(1)) + "%" },
                                m3: { title: this.SumSuanFa((actual.m3.title / forecast.m3.title * 100).toFixed(1)) + "%" },
                                m4: { title: this.SumSuanFa((actual.m4.title / forecast.m4.title * 100).toFixed(1)) + "%" },
                                m5: { title: this.SumSuanFa((actual.m5.title / forecast.m5.title * 100).toFixed(1)) + "%" },
                                m6: { title: this.SumSuanFa((actual.m6.title / forecast.m6.title * 100).toFixed(1)) + "%" },
                                m7: { title: this.SumSuanFa((actual.m7.title / forecast.m7.title * 100).toFixed(1)) + "%" },
                                m8: { title: this.SumSuanFa((actual.m8.title / forecast.m8.title * 100).toFixed(1)) + "%" },
                                m9: { title: this.SumSuanFa((actual.m9.title / forecast.m9.title * 100).toFixed(1)) + "%" },
                                m10: { title: this.SumSuanFa((actual.m10.title / forecast.m10.title * 100).toFixed(1)) + "%" },
                                m11: { title: this.SumSuanFa((actual.m11.title / forecast.m11.title * 100).toFixed(1)) + "%" },
                                m12: { title: this.SumSuanFa((actual.m12.title / forecast.m12.title * 100).toFixed(1)) + "%" },
                            }

                            item.tableData.push(target)
                            item.tableData.push(forecast)
                            item.tableData.push(actual)
                            item.tableData.push(dcl)
                        }
                        // console.log(this.TerritoryArray,111)
                        loading.close()
                    }
                })
                let objArray = this.TerritoryArray[this.tab].tableData

                for (let j = 0; j < objArray.length; j++) {//循环 objArray数组
                    if (objArray[j].title == '指标') {
                        target.push(objArray[j])
                    }
                    else if (objArray[j].title == '预估') {
                        forecast.push(objArray[j])
                    }
                    else if (objArray[j].title == '实际') {
                        actual.push(objArray[j])
                    }
                    else if (objArray[j].title == '达成率') {
                        dcl.push(objArray[j])
                    }
                }
                //console.log(target,forecast,actual,dcl)

                let targetT = {
                    restul: 0,
                    restul2: 0,
                    restul3: 0,
                    restul4: 0,
                    restul5: 0,
                    restul6: 0,
                    restul7: 0,
                    restul8: 0,
                    restul9: 0,
                    restul10: 0,
                    restul11: 0,
                    restul12: 0,
                    title: '',
                    name: ''

                }
                let forecastF = {
                    restul: 0,
                    restul2: 0,
                    restul3: 0,
                    restul4: 0,
                    restul5: 0,
                    restul6: 0,
                    restul7: 0,
                    restul8: 0,
                    restul9: 0,
                    restul10: 0,
                    restul11: 0,
                    restul12: 0,
                    title: '',
                    name: ''

                }
                let actualA = {
                    restul: 0,
                    restul2: 0,
                    restul3: 0,
                    restul4: 0,
                    restul5: 0,
                    restul6: 0,
                    restul7: 0,
                    restul8: 0,
                    restul9: 0,
                    restul10: 0,
                    restul11: 0,
                    restul12: 0,
                    title: '',
                    name: ''

                }
                let dclD = {
                    restul: 0,
                    restul2: 0,
                    restul3: 0,
                    restul4: 0,
                    restul5: 0,
                    restul6: 0,
                    restul7: 0,
                    restul8: 0,
                    restul9: 0,
                    restul10: 0,
                    restul11: 0,
                    restul12: 0,
                    title: '',
                    name: ''

                }
                for (let i = 0; i < target.length; i++) {
                    let objT = target[i]
                    targetT.title = objT.title
                    targetT.name = '合计(数量)'
                    targetT.restul += parseInt(objT.m1.title || 0)
                    targetT.restul2 += parseInt(objT.m2.title || 0)
                    targetT.restul3 += parseInt(objT.m3.title || 0)
                    targetT.restul4 += parseInt(objT.m4.title || 0)
                    targetT.restul5 += parseInt(objT.m5.title || 0)
                    targetT.restul6 += parseInt(objT.m6.title || 0)
                    targetT.restul7 += parseInt(objT.m7.title || 0)
                    targetT.restul8 += parseInt(objT.m8.title || 0)
                    targetT.restul9 += parseInt(objT.m9.title || 0)
                    targetT.restul10 += parseInt(objT.m10.title || 0)
                    targetT.restul11 += parseInt(objT.m11.title || 0)
                    targetT.restul12 += parseInt(objT.m12.title || 0)
                }
                for (let i = 0; i < forecast.length; i++) {
                    let objF = forecast[i]
                    forecastF.title = objF.title
                    forecastF.name = '合计(数量)'
                    forecastF.restul += parseInt(objF.m1.title || 0)
                    forecastF.restul2 += parseInt(objF.m2.title || 0)
                    forecastF.restul3 += parseInt(objF.m3.title || 0)
                    forecastF.restul4 += parseInt(objF.m4.title || 0)
                    forecastF.restul5 += parseInt(objF.m5.title || 0)
                    forecastF.restul6 += parseInt(objF.m6.title || 0)
                    forecastF.restul7 += parseInt(objF.m7.title || 0)
                    forecastF.restul8 += parseInt(objF.m8.title || 0)
                    forecastF.restul9 += parseInt(objF.m9.title || 0)
                    forecastF.restul10 += parseInt(objF.m10.title || 0)
                    forecastF.restul11 += parseInt(objF.m11.title || 0)
                    forecastF.restul12 += parseInt(objF.m12.title || 0)
                }
                for (let i = 0; i < actual.length; i++) {
                    let objA = actual[i]
                    actualA.title = objA.title
                    actualA.name = '合计(数量)'
                    actualA.restul += parseInt(objA.m1.title || 0)
                    actualA.restul2 += parseInt(objA.m2.title || 0)
                    actualA.restul3 += parseInt(objA.m3.title || 0)
                    actualA.restul4 += parseInt(objA.m4.title || 0)
                    actualA.restul5 += parseInt(objA.m5.title || 0)
                    actualA.restul6 += parseInt(objA.m6.title || 0)
                    actualA.restul7 += parseInt(objA.m7.title || 0)
                    actualA.restul8 += parseInt(objA.m8.title || 0)
                    actualA.restul9 += parseInt(objA.m9.title || 0)
                    actualA.restul10 += parseInt(objA.m10.title || 0)
                    actualA.restul11 += parseInt(objA.m11.title || 0)
                    actualA.restul12 += parseInt(objA.m12.title || 0)
                }
                for (let i = 0; i < dcl.length; i++) {
                    let objD = dcl[i]
                    dclD.title = objD.title
                    dclD.name = '合计(数量)'
                    dclD.restul += this.fangfa3(parseInt(objD.m1.title.split('%')[0]))
                    dclD.restul2 += this.fangfa3(parseInt(objD.m2.title.split('%')[0]))
                    dclD.restul3 += this.fangfa3(parseInt(objD.m3.title.split('%')[0]))
                    dclD.restul4 += this.fangfa3(parseInt(objD.m4.title.split('%')[0]))
                    dclD.restul5 += this.fangfa3(parseInt(objD.m5.title.split('%')[0]))
                    dclD.restul6 += this.fangfa3(parseInt(objD.m6.title.split('%')[0]))
                    dclD.restul7 += this.fangfa3(parseInt(objD.m7.title.split('%')[0]))
                    dclD.restul8 += this.fangfa3(parseInt(objD.m8.title.split('%')[0]))
                    dclD.restul9 += this.fangfa3(parseInt(objD.m9.title.split('%')[0]))
                    dclD.restul10 += this.fangfa3(parseInt(objD.m10.title.split('%')[0]))
                    dclD.restul11 += this.fangfa3(parseInt(objD.m11.title.split('%')[0]))
                    dclD.restul12 += this.fangfa3(parseInt(objD.m12.title.split('%')[0]))
                }
                this.NewtableData = [targetT, forecastF, actualA, dclD]

                //console.log('11111',this.NewtableData)




            },
            arraySpanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 0) {
                    if (rowIndex % 4 === 0) {
                        return {
                            rowspan: 4,
                            colspan: 1
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            },
            mystyle(obj) {
                let month1 = parseInt(new Date().getMonth()) + 1
                let a = parseInt(obj.column.label)
                if (a == month1) {
                    return {
                        color: '#ff9901'
                    }
                } else {
                    return {
                        color: '#585757'
                    }
                }

            },
            SumSuanFa(m) {
                if (isNaN(m)) {
                    return '--'
                } else {
                    if (m = 'Infinity') {
                        return '--'
                    }
                    return m
                }
            },
            rowClass() {
                return "background-color: #f9f9f9";
            },
            baocun() {

                this.saveSalesByEndPoint()
            },
            dianji4(item) {
                if (this.array.length == 0) {
                    Message({
                        type: 'error',
                        message: '暂无辖区'
                    });
                    return false
                }
                this.territoryArray = []
                this.territoryList = []
                this.territoryList = [...this.array]
                this.targetAmount = 0
                this.forecastAmount = 0
                this.dcLv = 0
                this.actualAmount = 0
                this.oldActualAmount = 0
                this.zzLV = 0

                for (var i = 0; i < this.array.length; i++) {
                    this.array[i].isSelect = item
                    if (item) {
                        let a = this.array[i].territory_id
                        this.territoryArray.push(a)
                        this.targetAmount += parseInt(this.array[i].targetAmount || 0) / 10000,
                            this.forecastAmount += parseInt(this.array[i].forecastAmount || 0) / 10000,
                            this.dcLv += this.fangfa3(parseInt(this.array[i].dcLv || 0)),
                            this.actualAmount += parseInt(this.array[i].actualAmount || 0) / 10000,
                            this.oldActualAmount += parseInt(this.array[i].oldActualAmount || 0) / 10000,
                            this.zzLV += this.fangfa3(parseInt(this.array[i].zzLV || 0))
                    }
                }
                //console.log(item)

                this.getSalesListByTerritoryIds()
            },
            selectBack(item) {

                for (var i = 0; i < this.array.length; i++) {
                    this.array[i].isSelect = false
                }

                this.territory_name = item.territory_name,
                    this.territory_code = item.territory_code,
                    this.alias = item.alias
                this.territoryArray = []
                this.territoryList = []
                this.territoryList.push(item)
                let a = item.territory_id
                this.territoryArray.push(a)
                this.xiaoshou = false
                item.isSelect = true
                this.mm = item.mm

                this.targetAmount = parseInt(item.targetAmount) / 10000,
                    this.forecastAmount = parseInt(item.forecastAmount || 0) / 10000,
                    this.dcLv = parseInt(item.dcLv || 0),
                    this.actualAmount = parseInt(item.actualAmount || 0) / 10000,
                    this.oldActualAmount = parseInt(item.oldActualAmount || 0) / 10000,
                    this.zzLV = this.fangfa3(parseInt(item.zzLV)),


                    this.getSalesListByTerritoryIds()
                this.MySum()
            },
            fangfa3(a) {
                if (isNaN(a)) {
                    return 0
                } else {
                    return a
                }

            },

            dianji3(item) {


                //                if (this.territoryArray.length == 0){
                //                    this.territory_name=item.territory_name,
                //                        this.territory_code=item.territory_code,
                //                        this.alias=item.alias
                //                    item.isSelect = true
                //                    this.territoryArray.push(item.territory_id)
                //                    this.getSalesListByTerritoryIds()
                //                    return
                //
                //                }else {
                //                    var b = false
                //
                //
                //                    for (var i = 0; i < this.territoryArray.length; i++){
                //                        let territory_id = this.territoryArray[i]
                //                        if (territory_id == item.territory_id){
                //                            item.isSelect = false
                //                            this.territoryArray.splice(i,1)
                //                            b = true
                //                            this.getSalesListByTerritoryIds()
                //                            return
                //                        }
                //                    }
                //
                //
                //                    if (b == false) {
                //                        item.isSelect = true
                //                        this.territoryArray.push(item.territory_id)
                //                        this.getSalesListByTerritoryIds()
                //                        return
                //                    }
                //
                //                }
                if (this.territoryList.length == 0) {
                    this.territoryArray = []
                    this.territoryList = []
                    item.isSelect = true
                    this.territoryArray.push(item.territory_id)
                    this.territoryList.push(item)
                    this.territory_name = item.territory_name,
                        this.territory_code = item.territory_code,
                        this.alias = item.alias

                    this.mm = item.mm
                    this.targetAmount = parseInt(item.targetAmount) / 10000,
                        this.forecastAmount = parseInt(item.forecastAmount || 0) / 10000,
                        this.dcLv = parseInt(item.dcLv || 0),
                        this.actualAmount = parseInt(item.actualAmount || 0) / 10000,
                        this.oldActualAmount = parseInt(item.oldActualAmount || 0) / 10000,
                        this.zzLV = this.fangfa3(parseInt(item.zzLV)),

                        this.getSalesListByTerritoryIds()
                    // this.MySum()
                    return
                } else {
                    var b = false
                    for (var i = 0; i < this.territoryList.length; i++) {
                        let ArrayList = this.territoryList[i]
                        if (ArrayList.territory_id == item.territory_id) {

                            item.isSelect = false
                            this.territory_name = '',
                                this.territory_code = '',
                                this.alias = ''
                            this.territoryArray.splice(i, 1)
                            this.territoryList.splice(i, 1)
                            this.xiaoshou = true
                            this.targetAmount -= parseInt(item.targetAmount) / 10000,
                                this.forecastAmount -= parseInt(item.forecastAmount || 0) / 10000,
                                this.dcLv -= parseInt(item.dcLv || 0),
                                this.actualAmount -= parseInt(item.actualAmount || 0) / 10000,
                                this.oldActualAmount -= parseInt(item.oldActualAmount || 0) / 10000,
                                this.zzLV -= this.fangfa3(parseInt(item.zzLV))

                            if (this.territoryList.length == 1) {
                                for (let j = 0; j < this.territoryList.length; j++) {
                                    let a = this.territoryList[j]
                                    this.territory_name = a.territory_name,
                                        this.territory_code = a.territory_code,
                                        this.alias = a.alias
                                }
                            }
                            b = true
                            this.getSalesListByTerritoryIds()
                            this.MySum()
                            console.log(this.territoryList)
                            return
                        }
                    }
                    if (b == false) {
                        item.isSelect = true
                        this.territoryArray.push(item.territory_id)
                        this.territoryList.push(item)

                        this.targetAmount += parseInt(item.targetAmount) / 10000,
                            this.forecastAmount += parseInt(item.forecastAmount || 0) / 10000,
                            this.dcLv += parseInt(item.dcLv || 0),
                            this.actualAmount += parseInt(item.actualAmount || 0) / 10000,
                            this.oldActualAmount += parseInt(item.oldActualAmount || 0) / 10000,
                            this.zzLV += this.fangfa3(parseInt(item.zzLV)),

                            this.getSalesListByTerritoryIds()
                        this.MySum()
                        //  console.log(this.targetAmount)
                        return
                    }
                }

            },
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 0) {
                    if (rowIndex % 4 === 0) {
                        return {
                            rowspan: 4,
                            colspan: 1
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
                if (columnIndex === 1) {
                    if (rowIndex % 4 === 0) {
                        return {
                            rowspan: 4,
                            colspan: 1
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            },
            fangfa() {
                // if(this.form.year!=='' && this.form.TerritoryList!==''){
                //     this.getSalesTerritoryList()
                // }
                if (this.territoryArray.length > 0) {
                    this.getSalesListByTerritoryIds()
                }

            },

            fangfa2(item) {
                this.TerritoryArray = []
                // this.loading=true
                if (item == '按产品') {
                    this.key = 'PRODUCT'
                    // this.loading=true
                } else if (item == '按客户') {
                    this.key = 'INSTITUTION'
                    // this.loading=true
                }
                this.getSalesListByTerritoryIds()

            },
            xuanze() {
                if (this.form.year !== '' && this.form.TerritoryList !== '') {
                    this.getSalesTerritoryList()
                }
            },
            //辖区
            async getTerritoryList() {

                let data = {
                    user_id: this.$store.getters.getUser.user_id,
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }
                let self = this
                await http.post('/wapi/Territory/getTerritoryList', data).then(res => {

                    if (res.success) {
                        self.TerritoryList = res.data
                        for (var i = 0; i < self.TerritoryList.length; i++) {
                            let a = self.TerritoryList[i]
                            if (i == 0 && this.form.TerritoryList == '') {
                                this.form.TerritoryList = a.territory_id
                            }
                        }
                        this.getSalesTerritoryList()
                    } else {
                        Message.error(res.message);
                    }
                })
            },
            //辖区列表
            async getSalesTerritoryList() {
                this.loading = true
                let data = {
                    territory_id: this.form.TerritoryList == '' ? '11111111' : this.form.TerritoryList,
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    year: this.form.year,
                    user_id: this.$store.getters.getUser.user_id,
                }
                let self = this
                await http.post('/wapi/sales/getSalesTerritoryList', data).then(res => {

                    if (res.success) {
                        self.territoryList = []
                        for (var i = 0; i < res.data.length; i++) {
                            res.data[i].isSelect = false

                            if (self.territoryArray.length > 0) {
                                for (var j = 0; j < this.territoryArray.length; j++) {
                                    if (res.data[i].territory_id == this.territoryArray[j]) {
                                        res.data[i].isSelect = true
                                    }
                                }
                            }
                        }
                        self.array = res.data
                        this.loading = false
                    } else {
                        this.loading = false
                        //                        Message.error(res.message);
                    }
                    this.$nextTick(() => {
                        new Swiper('.swiper-container', {
                            slidesPerView: "auto",

                            freeMode: true,
                            navigation: {
                                nextEl: '.you',
                                prevEl: '.zuo',

                            },
                        });
                        if (this.role === 'staff') {
                            const firstNode = document.querySelector('.selectImg')
                            firstNode.click();
                        }
                    })
                })
            },
            //辖区数据
            async getSalesListByTerritoryIds() {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data = {
                        territoryIds: this.territoryArray,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        year: this.form.year,
                        user_id: this.$store.getters.getUser.user_id,
                        data_type: this.key,
                    }

                    await http.post('/wapi/sales/getSalesListByTerritoryIds', data).then(res => {

                        // console.log(res)
                        this.tab = 0
                        this.TerritoryArray = []
                        if (res.success) {
                            if (Array.isArray(res.data)) {
                                loading.close()
                            }
                            if (res.data.skuArray2.length > 0) {
                                this.activeName = res.data.skuArray2[0].sku_id
                                this.TerritoryArray = res.data.skuArray2
                                let array = res.data.array[0]
                                let item = res.data.skuArray2[0]
                                item.tableData = []
                                for (let j = 0; j < array.length; j++) {
                                    let o = array[j]
                                    //item.sku_name = this.key == 'PRODUCT' ? o.sku_name : o.name

                                    let target = {
                                        title: '指标',
                                        sort: parseInt(j) + 1,
                                        name: this.key == 'PRODUCT' ? o.name : o.sku_name,
                                        type: o.type,
                                        key_id: o.key_id,
                                        product_id: o.product_id,
                                        sku_id: o.sku_id,
                                        id: o.id,

                                        m1: { title: o.m1_target_quantity, disabled: this.panduan(res.data.targetArray[0]), amount: o.m1_target_amount },
                                        m2: { title: o.m2_target_quantity, disabled: this.panduan(res.data.targetArray[1]), amount: o.m2_target_amount },
                                        m3: { title: o.m3_target_quantity, disabled: this.panduan(res.data.targetArray[2]), amount: o.m3_target_amount },
                                        m4: { title: o.m4_target_quantity, disabled: this.panduan(res.data.targetArray[3]), amount: o.m4_target_amount },
                                        m5: { title: o.m5_target_quantity, disabled: this.panduan(res.data.targetArray[4]), amount: o.m5_target_amount },
                                        m6: { title: o.m6_target_quantity, disabled: this.panduan(res.data.targetArray[5]), amount: o.m6_target_amount },
                                        m7: { title: o.m7_target_quantity, disabled: this.panduan(res.data.targetArray[6]), amount: o.m7_target_amount },
                                        m8: { title: o.m8_target_quantity, disabled: this.panduan(res.data.targetArray[7]), amount: o.m8_target_amount },
                                        m9: { title: o.m9_target_quantity, disabled: this.panduan(res.data.targetArray[8]), amount: o.m9_target_amount },
                                        m10: { title: o.m10_target_quantity, disabled: this.panduan(res.data.targetArray[9]), amount: o.m10_target_amount },
                                        m11: { title: o.m11_target_quantity, disabled: this.panduan(res.data.targetArray[10]), amount: o.m11_target_amount },
                                        m12: { title: o.m12_target_quantity, disabled: this.panduan(res.data.targetArray[11]), amount: o.m12_target_amount },




                                    }
                                    let forecast = {
                                        title: '预估',
                                        sort: parseInt(j) + 1,
                                        name: this.key == 'PRODUCT' ? o.name : o.sku_name,
                                        type: o.type,
                                        key_id: o.key_id,
                                        product_id: o.product_id,
                                        sku_id: o.sku_id,
                                        id: o.id,

                                        m1: { title: o.m1_forecast_quantity, disabled: this.panduan(res.data.forecastArray[0]), amount: o.m1_forecast_amount },
                                        m2: { title: o.m2_forecast_quantity, disabled: this.panduan(res.data.forecastArray[1]), amount: o.m2_forecast_amount },
                                        m3: { title: o.m3_forecast_quantity, disabled: this.panduan(res.data.forecastArray[2]), amount: o.m3_forecast_amount },
                                        m4: { title: o.m4_forecast_quantity, disabled: this.panduan(res.data.forecastArray[3]), amount: o.m4_forecast_amount },
                                        m5: { title: o.m5_forecast_quantity, disabled: this.panduan(res.data.forecastArray[4]), amount: o.m5_forecast_amount },
                                        m6: { title: o.m6_forecast_quantity, disabled: this.panduan(res.data.forecastArray[5]), amount: o.m6_forecast_amount },
                                        m7: { title: o.m7_forecast_quantity, disabled: this.panduan(res.data.forecastArray[6]), amount: o.m7_forecast_amount },
                                        m8: { title: o.m8_forecast_quantity, disabled: this.panduan(res.data.forecastArray[7]), amount: o.m8_forecast_amount },
                                        m9: { title: o.m9_forecast_quantity, disabled: this.panduan(res.data.forecastArray[8]), amount: o.m9_forecast_amount },
                                        m10: { title: o.m10_forecast_quantity, disabled: this.panduan(res.data.forecastArray[9]), amount: o.m10_forecast_amount },
                                        m11: { title: o.m11_forecast_quantity, disabled: this.panduan(res.data.forecastArray[10]), amount: o.m11_forecast_amount },
                                        m12: { title: o.m12_forecast_quantity, disabled: this.panduan(res.data.forecastArray[11]), amount: o.m12_forecast_amount },
                                    }
                                    let actual = {
                                        title: '实际',
                                        sort: parseInt(j) + 1,
                                        name: this.key == 'PRODUCT' ? o.name : o.sku_name,
                                        type: o.type,
                                        key_id: o.key_id,
                                        product_id: o.product_id,
                                        sku_id: o.sku_id,
                                        id: o.id,

                                        m1: { title: o.m1_actual_quantity, disabled: this.panduan(res.data.actualArray[0]), amount: o.m1_actual_amount },
                                        m2: { title: o.m2_actual_quantity, disabled: this.panduan(res.data.actualArray[1]), amount: o.m2_actual_amount },
                                        m3: { title: o.m3_actual_quantity, disabled: this.panduan(res.data.actualArray[2]), amount: o.m3_actual_amount },
                                        m4: { title: o.m4_actual_quantity, disabled: this.panduan(res.data.actualArray[3]), amount: o.m4_actual_amount },
                                        m5: { title: o.m5_actual_quantity, disabled: this.panduan(res.data.actualArray[4]), amount: o.m5_actual_amount },
                                        m6: { title: o.m6_actual_quantity, disabled: this.panduan(res.data.actualArray[5]), amount: o.m6_actual_amount },
                                        m7: { title: o.m7_actual_quantity, disabled: this.panduan(res.data.actualArray[6]), amount: o.m7_actual_amount },
                                        m8: { title: o.m8_actual_quantity, disabled: this.panduan(res.data.actualArray[7]), amount: o.m8_actual_amount },
                                        m9: { title: o.m9_actual_quantity, disabled: this.panduan(res.data.actualArray[8]), amount: o.m9_actual_amount },
                                        m10: { title: o.m10_actual_quantity, disabled: this.panduan(res.data.actualArray[9]), amount: o.m10_actual_amount },
                                        m11: { title: o.m11_actual_quantity, disabled: this.panduan(res.data.actualArray[10]), amount: o.m11_actual_amount },
                                        m12: { title: o.m12_actual_quantity, disabled: this.panduan(res.data.actualArray[11]), amount: o.m12_actual_amount },
                                    }
                                    let dcl = {
                                        title: '达成率',
                                        sort: parseInt(j) + 1,
                                        name: this.key == 'PRODUCT' ? o.name : o.sku_name,
                                        type: o.type,
                                        key_id: o.key_id,
                                        product_id: o.product_id,
                                        sku_id: o.sku_id,

                                        m1: { title: this.SumSuanFa((actual.m1.title / forecast.m1.title * 100).toFixed(1)) + "%" },
                                        m2: { title: this.SumSuanFa((actual.m2.title / forecast.m2.title * 100).toFixed(1)) + "%" },
                                        m3: { title: this.SumSuanFa((actual.m3.title / forecast.m3.title * 100).toFixed(1)) + "%" },
                                        m4: { title: this.SumSuanFa((actual.m4.title / forecast.m4.title * 100).toFixed(1)) + "%" },
                                        m5: { title: this.SumSuanFa((actual.m5.title / forecast.m5.title * 100).toFixed(1)) + "%" },
                                        m6: { title: this.SumSuanFa((actual.m6.title / forecast.m6.title * 100).toFixed(1)) + "%" },
                                        m7: { title: this.SumSuanFa((actual.m7.title / forecast.m7.title * 100).toFixed(1)) + "%" },
                                        m8: { title: this.SumSuanFa((actual.m8.title / forecast.m8.title * 100).toFixed(1)) + "%" },
                                        m9: { title: this.SumSuanFa((actual.m9.title / forecast.m9.title * 100).toFixed(1)) + "%" },
                                        m10: { title: this.SumSuanFa((actual.m10.title / forecast.m10.title * 100).toFixed(1)) + "%" },
                                        m11: { title: this.SumSuanFa((actual.m11.title / forecast.m11.title * 100).toFixed(1)) + "%" },
                                        m12: { title: this.SumSuanFa((actual.m12.title / forecast.m12.title * 100).toFixed(1)) + "%" },
                                    }

                                    item.tableData.push(target)
                                    item.tableData.push(forecast)
                                    item.tableData.push(actual)
                                    item.tableData.push(dcl)
                                }
                            }

                            if (res.data.allArray.length > 0) {
                                this.activeName = res.data.allArray[0].institution_id || res.data.allArray[0].store_id || res.data.allArray[0].distributor_id
                                this.TerritoryArray = res.data.allArray
                                let array = res.data.array[0]
                                let item = res.data.allArray[0]
                                item.tableData = []
                                for (let j = 0; j < array.length; j++) {
                                    let o = array[j]
                                    item.sku_name = this.key == 'PRODUCT' ? o.sku_name : o.name

                                    let target = {
                                        title: '指标',
                                        sort: parseInt(j) + 1,
                                        name: this.key == 'PRODUCT' ? o.name : o.sku_name,
                                        type: o.type,
                                        key_id: o.key_id,
                                        product_id: o.product_id,
                                        sku_id: o.sku_id,
                                        id: o.id,

                                        m1: { title: o.m1_target_quantity, disabled: this.panduan(res.data.targetArray[0]), amount: o.m1_target_amount },
                                        m2: { title: o.m2_target_quantity, disabled: this.panduan(res.data.targetArray[1]), amount: o.m2_target_amount },
                                        m3: { title: o.m3_target_quantity, disabled: this.panduan(res.data.targetArray[2]), amount: o.m3_target_amount },
                                        m4: { title: o.m4_target_quantity, disabled: this.panduan(res.data.targetArray[3]), amount: o.m4_target_amount },
                                        m5: { title: o.m5_target_quantity, disabled: this.panduan(res.data.targetArray[4]), amount: o.m5_target_amount },
                                        m6: { title: o.m6_target_quantity, disabled: this.panduan(res.data.targetArray[5]), amount: o.m6_target_amount },
                                        m7: { title: o.m7_target_quantity, disabled: this.panduan(res.data.targetArray[6]), amount: o.m7_target_amount },
                                        m8: { title: o.m8_target_quantity, disabled: this.panduan(res.data.targetArray[7]), amount: o.m8_target_amount },
                                        m9: { title: o.m9_target_quantity, disabled: this.panduan(res.data.targetArray[8]), amount: o.m9_target_amount },
                                        m10: { title: o.m10_target_quantity, disabled: this.panduan(res.data.targetArray[9]), amount: o.m10_target_amount },
                                        m11: { title: o.m11_target_quantity, disabled: this.panduan(res.data.targetArray[10]), amount: o.m11_target_amount },
                                        m12: { title: o.m12_target_quantity, disabled: this.panduan(res.data.targetArray[11]), amount: o.m12_target_amount },




                                    }
                                    let forecast = {
                                        title: '预估',
                                        sort: parseInt(j) + 1,
                                        name: this.key == 'PRODUCT' ? o.name : o.sku_name,
                                        type: o.type,
                                        key_id: o.key_id,
                                        product_id: o.product_id,
                                        sku_id: o.sku_id,
                                        id: o.id,

                                        m1: { title: o.m1_forecast_quantity, disabled: this.panduan(res.data.forecastArray[0]), amount: o.m1_forecast_amount },
                                        m2: { title: o.m2_forecast_quantity, disabled: this.panduan(res.data.forecastArray[1]), amount: o.m2_forecast_amount },
                                        m3: { title: o.m3_forecast_quantity, disabled: this.panduan(res.data.forecastArray[2]), amount: o.m3_forecast_amount },
                                        m4: { title: o.m4_forecast_quantity, disabled: this.panduan(res.data.forecastArray[3]), amount: o.m4_forecast_amount },
                                        m5: { title: o.m5_forecast_quantity, disabled: this.panduan(res.data.forecastArray[4]), amount: o.m5_forecast_amount },
                                        m6: { title: o.m6_forecast_quantity, disabled: this.panduan(res.data.forecastArray[5]), amount: o.m6_forecast_amount },
                                        m7: { title: o.m7_forecast_quantity, disabled: this.panduan(res.data.forecastArray[6]), amount: o.m7_forecast_amount },
                                        m8: { title: o.m8_forecast_quantity, disabled: this.panduan(res.data.forecastArray[7]), amount: o.m8_forecast_amount },
                                        m9: { title: o.m9_forecast_quantity, disabled: this.panduan(res.data.forecastArray[8]), amount: o.m9_forecast_amount },
                                        m10: { title: o.m10_forecast_quantity, disabled: this.panduan(res.data.forecastArray[9]), amount: o.m10_forecast_amount },
                                        m11: { title: o.m11_forecast_quantity, disabled: this.panduan(res.data.forecastArray[10]), amount: o.m11_forecast_amount },
                                        m12: { title: o.m12_forecast_quantity, disabled: this.panduan(res.data.forecastArray[11]), amount: o.m12_forecast_amount },
                                    }
                                    let actual = {
                                        title: '实际',
                                        sort: parseInt(j) + 1,
                                        name: this.key == 'PRODUCT' ? o.name : o.sku_name,
                                        type: o.type,
                                        key_id: o.key_id,
                                        product_id: o.product_id,
                                        sku_id: o.sku_id,
                                        id: o.id,

                                        m1: { title: o.m1_actual_quantity, disabled: this.panduan(res.data.actualArray[0]), amount: o.m1_actual_amount },
                                        m2: { title: o.m2_actual_quantity, disabled: this.panduan(res.data.actualArray[1]), amount: o.m2_actual_amount },
                                        m3: { title: o.m3_actual_quantity, disabled: this.panduan(res.data.actualArray[2]), amount: o.m3_actual_amount },
                                        m4: { title: o.m4_actual_quantity, disabled: this.panduan(res.data.actualArray[3]), amount: o.m4_actual_amount },
                                        m5: { title: o.m5_actual_quantity, disabled: this.panduan(res.data.actualArray[4]), amount: o.m5_actual_amount },
                                        m6: { title: o.m6_actual_quantity, disabled: this.panduan(res.data.actualArray[5]), amount: o.m6_actual_amount },
                                        m7: { title: o.m7_actual_quantity, disabled: this.panduan(res.data.actualArray[6]), amount: o.m7_actual_amount },
                                        m8: { title: o.m8_actual_quantity, disabled: this.panduan(res.data.actualArray[7]), amount: o.m8_actual_amount },
                                        m9: { title: o.m9_actual_quantity, disabled: this.panduan(res.data.actualArray[8]), amount: o.m9_actual_amount },
                                        m10: { title: o.m10_actual_quantity, disabled: this.panduan(res.data.actualArray[9]), amount: o.m10_actual_amount },
                                        m11: { title: o.m11_actual_quantity, disabled: this.panduan(res.data.actualArray[10]), amount: o.m11_actual_amount },
                                        m12: { title: o.m12_actual_quantity, disabled: this.panduan(res.data.actualArray[11]), amount: o.m12_actual_amount },
                                    }
                                    let dcl = {
                                        title: '达成率',
                                        sort: parseInt(j) + 1,
                                        name: this.key == 'PRODUCT' ? o.name : o.sku_name,
                                        type: o.type,
                                        key_id: o.key_id,
                                        product_id: o.product_id,
                                        sku_id: o.sku_id,

                                        m1: { title: this.SumSuanFa((actual.m1.title / forecast.m1.title * 100).toFixed(1)) + "%" },
                                        m2: { title: this.SumSuanFa((actual.m2.title / forecast.m2.title * 100).toFixed(1)) + "%" },
                                        m3: { title: this.SumSuanFa((actual.m3.title / forecast.m3.title * 100).toFixed(1)) + "%" },
                                        m4: { title: this.SumSuanFa((actual.m4.title / forecast.m4.title * 100).toFixed(1)) + "%" },
                                        m5: { title: this.SumSuanFa((actual.m5.title / forecast.m5.title * 100).toFixed(1)) + "%" },
                                        m6: { title: this.SumSuanFa((actual.m6.title / forecast.m6.title * 100).toFixed(1)) + "%" },
                                        m7: { title: this.SumSuanFa((actual.m7.title / forecast.m7.title * 100).toFixed(1)) + "%" },
                                        m8: { title: this.SumSuanFa((actual.m8.title / forecast.m8.title * 100).toFixed(1)) + "%" },
                                        m9: { title: this.SumSuanFa((actual.m9.title / forecast.m9.title * 100).toFixed(1)) + "%" },
                                        m10: { title: this.SumSuanFa((actual.m10.title / forecast.m10.title * 100).toFixed(1)) + "%" },
                                        m11: { title: this.SumSuanFa((actual.m11.title / forecast.m11.title * 100).toFixed(1)) + "%" },
                                        m12: { title: this.SumSuanFa((actual.m12.title / forecast.m12.title * 100).toFixed(1)) + "%" },
                                    }

                                    item.tableData.push(target)
                                    item.tableData.push(forecast)
                                    item.tableData.push(actual)
                                    item.tableData.push(dcl)
                                }
                                console.log(this.TerritoryArray, 99)
                            }

                            // for(var i=0;i<res.data.array.length;i++){

                            // if (array.length > 0) {
                            //     this.TerritoryArray.push(item)
                            //     //console.log(this.TerritoryArray)
                            // }
                            debugger;
                            this.newAllArray = []
                            console.log('---===============================-')
                            console.log(this.TerritoryArray);
                            this.newAllArray = this.TerritoryArray.slice(0, 50)
                            // this.newAllArray.shift()
                            console.log('----------------------------')
                            console.log(this.newAllArray);
                            debugger
                            loading.close()
                            this.MySum()
                            // }
                            this.handleEvent()

                            // this.loading = false
                        } else {
                            loading.close()
                        }

                    })

                } catch (e) {
                    Message.error(res.message);
                    loading.close()
                }



            },
            //保存
            async saveSalesByEndPoint() {
                this.loading = true
                let data_array = []
                for (let i = 0; i < this.TerritoryArray.length; i++) {
                    let item = this.TerritoryArray[i]
                    if (item.tableData && item.tableData.length > 0) {

                        for (let j = 0; j < item.tableData.length / 4; j++) {

                            let obj = {}
                            let targetObj = item.tableData[j * 4]
                            let forecastObj = item.tableData[j * 4 + 1]
                            let actualObj = item.tableData[j * 4 + 2]

                            obj.type = targetObj.type
                            obj.key_id = targetObj.key_id
                            obj.sku_id = targetObj.sku_id
                            obj.product_id = targetObj.product_id
                            obj.id = targetObj.id

                            obj.m1_target_quantity = targetObj.m1.title
                            obj.m2_target_quantity = targetObj.m2.title
                            obj.m3_target_quantity = targetObj.m3.title
                            obj.m4_target_quantity = targetObj.m4.title
                            obj.m5_target_quantity = targetObj.m5.title
                            obj.m6_target_quantity = targetObj.m6.title
                            obj.m7_target_quantity = targetObj.m7.title
                            obj.m8_target_quantity = targetObj.m7.title
                            obj.m9_target_quantity = targetObj.m9.title
                            obj.m10_target_quantity = targetObj.m10.title
                            obj.m11_target_quantity = targetObj.m11.title
                            obj.m12_target_quantity = targetObj.m12.title

                            obj.m1_forecast_quantity = forecastObj.m1.title
                            obj.m2_forecast_quantity = forecastObj.m2.title
                            obj.m3_forecast_quantity = forecastObj.m3.title
                            obj.m4_forecast_quantity = forecastObj.m4.title
                            obj.m5_forecast_quantity = forecastObj.m5.title
                            obj.m6_forecast_quantity = forecastObj.m6.title
                            obj.m7_forecast_quantity = forecastObj.m7.title
                            obj.m8_forecast_quantity = forecastObj.m8.title
                            obj.m9_forecast_quantity = forecastObj.m9.title
                            obj.m10_forecast_quantity = forecastObj.m10.title
                            obj.m11_forecast_quantity = forecastObj.m11.title
                            obj.m12_forecast_quantity = forecastObj.m12.title

                            obj.m1_actual_quantity = actualObj.m1.title
                            obj.m2_actual_quantity = actualObj.m2.title
                            obj.m3_actual_quantity = actualObj.m3.title
                            obj.m4_actual_quantity = actualObj.m4.title
                            obj.m5_actual_quantity = actualObj.m5.title
                            obj.m6_actual_quantity = actualObj.m6.title
                            obj.m7_actual_quantity = actualObj.m7.title
                            obj.m8_actual_quantity = actualObj.m8.title
                            obj.m9_actual_quantity = actualObj.m9.title
                            obj.m10_actual_quantity = actualObj.m10.title
                            obj.m11_actual_quantity = actualObj.m11.title
                            obj.m12_actual_quantity = actualObj.m12.title

                            data_array.push(obj)
                        }
                    }
                }

                let data = {
                    user_id: this.$store.getters.getUser.user_id,
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    data_array: data_array
                }
                let self = this
                await http.post('/wapi/sales/saveSalesByEndPoint', data).then(res => {

                    if (res.success) {
                        this.loading = false
                        let obj = this.TerritoryArray[this.tab]
                        this.activeName = obj.sku_id || obj.institution_id || obj.store_id || obj.distributor_id
                        this.getSaveInfo()
                    } else {
                        Message.error(res.message);
                        this.loading = false
                    }
                })
            },
            async getSaveInfo() {

                this.NewtableData = []
                let target = []
                let forecast = []
                let actual = []
                let dcl = []
                let data = {
                    territoryIds: this.territoryArray,
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    year: this.form.year,
                    user_id: this.$store.getters.getUser.user_id,
                    obj: this.TerritoryArray[this.tab],
                    data_type: this.key
                }
                this.TerritoryArray[this.tab].tableData = []
                // console.log(this.TerritoryArray[this.tab])
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                await http.post('/wapi/sales/getSalesListBySkuId', data).then(res => {
                    if (res.success) {
                        let array = res.data.array[0]
                        let item = this.TerritoryArray[this.tab]
                        item.tableData = []
                        for (let j = 0; j < array.length; j++) {
                            let o = array[j]
                            item.sku_name = this.key == 'PRODUCT' ? o.sku_name : o.name

                            let target = {
                                title: '指标',
                                sort: parseInt(j) + 1,
                                name: this.key == 'PRODUCT' ? o.name : o.sku_name,
                                type: o.type,
                                key_id: o.key_id,
                                product_id: o.product_id,
                                sku_id: o.sku_id,
                                id: o.id,

                                m1: { title: o.m1_target_quantity, disabled: this.panduan(res.data.targetArray[0]), amount: o.m1_target_amount },
                                m2: { title: o.m2_target_quantity, disabled: this.panduan(res.data.targetArray[1]), amount: o.m2_target_amount },
                                m3: { title: o.m3_target_quantity, disabled: this.panduan(res.data.targetArray[2]), amount: o.m3_target_amount },
                                m4: { title: o.m4_target_quantity, disabled: this.panduan(res.data.targetArray[3]), amount: o.m4_target_amount },
                                m5: { title: o.m5_target_quantity, disabled: this.panduan(res.data.targetArray[4]), amount: o.m5_target_amount },
                                m6: { title: o.m6_target_quantity, disabled: this.panduan(res.data.targetArray[5]), amount: o.m6_target_amount },
                                m7: { title: o.m7_target_quantity, disabled: this.panduan(res.data.targetArray[6]), amount: o.m7_target_amount },
                                m8: { title: o.m8_target_quantity, disabled: this.panduan(res.data.targetArray[7]), amount: o.m8_target_amount },
                                m9: { title: o.m9_target_quantity, disabled: this.panduan(res.data.targetArray[8]), amount: o.m9_target_amount },
                                m10: { title: o.m10_target_quantity, disabled: this.panduan(res.data.targetArray[9]), amount: o.m10_target_amount },
                                m11: { title: o.m11_target_quantity, disabled: this.panduan(res.data.targetArray[10]), amount: o.m11_target_amount },
                                m12: { title: o.m12_target_quantity, disabled: this.panduan(res.data.targetArray[11]), amount: o.m12_target_amount },




                            }
                            let forecast = {
                                title: '预估',
                                sort: parseInt(j) + 1,
                                name: this.key == 'PRODUCT' ? o.name : o.sku_name,
                                type: o.type,
                                key_id: o.key_id,
                                product_id: o.product_id,
                                sku_id: o.sku_id,
                                id: o.id,

                                m1: { title: o.m1_forecast_quantity, disabled: this.panduan(res.data.forecastArray[0]), amount: o.m1_forecast_amount },
                                m2: { title: o.m2_forecast_quantity, disabled: this.panduan(res.data.forecastArray[1]), amount: o.m2_forecast_amount },
                                m3: { title: o.m3_forecast_quantity, disabled: this.panduan(res.data.forecastArray[2]), amount: o.m3_forecast_amount },
                                m4: { title: o.m4_forecast_quantity, disabled: this.panduan(res.data.forecastArray[3]), amount: o.m4_forecast_amount },
                                m5: { title: o.m5_forecast_quantity, disabled: this.panduan(res.data.forecastArray[4]), amount: o.m5_forecast_amount },
                                m6: { title: o.m6_forecast_quantity, disabled: this.panduan(res.data.forecastArray[5]), amount: o.m6_forecast_amount },
                                m7: { title: o.m7_forecast_quantity, disabled: this.panduan(res.data.forecastArray[6]), amount: o.m7_forecast_amount },
                                m8: { title: o.m8_forecast_quantity, disabled: this.panduan(res.data.forecastArray[7]), amount: o.m8_forecast_amount },
                                m9: { title: o.m9_forecast_quantity, disabled: this.panduan(res.data.forecastArray[8]), amount: o.m9_forecast_amount },
                                m10: { title: o.m10_forecast_quantity, disabled: this.panduan(res.data.forecastArray[9]), amount: o.m10_forecast_amount },
                                m11: { title: o.m11_forecast_quantity, disabled: this.panduan(res.data.forecastArray[10]), amount: o.m11_forecast_amount },
                                m12: { title: o.m12_forecast_quantity, disabled: this.panduan(res.data.forecastArray[11]), amount: o.m12_forecast_amount },
                            }
                            let actual = {
                                title: '实际',
                                sort: parseInt(j) + 1,
                                name: this.key == 'PRODUCT' ? o.name : o.sku_name,
                                type: o.type,
                                key_id: o.key_id,
                                product_id: o.product_id,
                                sku_id: o.sku_id,
                                id: o.id,

                                m1: { title: o.m1_actual_quantity, disabled: this.panduan(res.data.actualArray[0]), amount: o.m1_actual_amount },
                                m2: { title: o.m2_actual_quantity, disabled: this.panduan(res.data.actualArray[1]), amount: o.m2_actual_amount },
                                m3: { title: o.m3_actual_quantity, disabled: this.panduan(res.data.actualArray[2]), amount: o.m3_actual_amount },
                                m4: { title: o.m4_actual_quantity, disabled: this.panduan(res.data.actualArray[3]), amount: o.m4_actual_amount },
                                m5: { title: o.m5_actual_quantity, disabled: this.panduan(res.data.actualArray[4]), amount: o.m5_actual_amount },
                                m6: { title: o.m6_actual_quantity, disabled: this.panduan(res.data.actualArray[5]), amount: o.m6_actual_amount },
                                m7: { title: o.m7_actual_quantity, disabled: this.panduan(res.data.actualArray[6]), amount: o.m7_actual_amount },
                                m8: { title: o.m8_actual_quantity, disabled: this.panduan(res.data.actualArray[7]), amount: o.m8_actual_amount },
                                m9: { title: o.m9_actual_quantity, disabled: this.panduan(res.data.actualArray[8]), amount: o.m9_actual_amount },
                                m10: { title: o.m10_actual_quantity, disabled: this.panduan(res.data.actualArray[9]), amount: o.m10_actual_amount },
                                m11: { title: o.m11_actual_quantity, disabled: this.panduan(res.data.actualArray[10]), amount: o.m11_actual_amount },
                                m12: { title: o.m12_actual_quantity, disabled: this.panduan(res.data.actualArray[11]), amount: o.m12_actual_amount },
                            }
                            let dcl = {
                                title: '达成率',
                                sort: parseInt(j) + 1,
                                name: this.key == 'PRODUCT' ? o.name : o.sku_name,
                                type: o.type,
                                key_id: o.key_id,
                                product_id: o.product_id,
                                sku_id: o.sku_id,

                                m1: { title: this.SumSuanFa((actual.m1.title / forecast.m1.title * 100).toFixed(1)) + "%" },
                                m2: { title: this.SumSuanFa((actual.m2.title / forecast.m2.title * 100).toFixed(1)) + "%" },
                                m3: { title: this.SumSuanFa((actual.m3.title / forecast.m3.title * 100).toFixed(1)) + "%" },
                                m4: { title: this.SumSuanFa((actual.m4.title / forecast.m4.title * 100).toFixed(1)) + "%" },
                                m5: { title: this.SumSuanFa((actual.m5.title / forecast.m5.title * 100).toFixed(1)) + "%" },
                                m6: { title: this.SumSuanFa((actual.m6.title / forecast.m6.title * 100).toFixed(1)) + "%" },
                                m7: { title: this.SumSuanFa((actual.m7.title / forecast.m7.title * 100).toFixed(1)) + "%" },
                                m8: { title: this.SumSuanFa((actual.m8.title / forecast.m8.title * 100).toFixed(1)) + "%" },
                                m9: { title: this.SumSuanFa((actual.m9.title / forecast.m9.title * 100).toFixed(1)) + "%" },
                                m10: { title: this.SumSuanFa((actual.m10.title / forecast.m10.title * 100).toFixed(1)) + "%" },
                                m11: { title: this.SumSuanFa((actual.m11.title / forecast.m11.title * 100).toFixed(1)) + "%" },
                                m12: { title: this.SumSuanFa((actual.m12.title / forecast.m12.title * 100).toFixed(1)) + "%" },
                            }

                            item.tableData.push(target)
                            item.tableData.push(forecast)
                            item.tableData.push(actual)
                            item.tableData.push(dcl)
                        }
                        // console.log(this.TerritoryArray,111)
                        loading.close()
                    }
                })
                let objArray = this.TerritoryArray[this.tab].tableData

                for (let j = 0; j < objArray.length; j++) {//循环 objArray数组
                    if (objArray[j].title == '指标') {
                        target.push(objArray[j])
                    }
                    else if (objArray[j].title == '预估') {
                        forecast.push(objArray[j])
                    }
                    else if (objArray[j].title == '实际') {
                        actual.push(objArray[j])
                    }
                    else if (objArray[j].title == '达成率') {
                        dcl.push(objArray[j])
                    }
                }
                //console.log(target,forecast,actual,dcl)

                let targetT = {
                    restul: 0,
                    restul2: 0,
                    restul3: 0,
                    restul4: 0,
                    restul5: 0,
                    restul6: 0,
                    restul7: 0,
                    restul8: 0,
                    restul9: 0,
                    restul10: 0,
                    restul11: 0,
                    restul12: 0,
                    title: '',
                    name: ''

                }
                let forecastF = {
                    restul: 0,
                    restul2: 0,
                    restul3: 0,
                    restul4: 0,
                    restul5: 0,
                    restul6: 0,
                    restul7: 0,
                    restul8: 0,
                    restul9: 0,
                    restul10: 0,
                    restul11: 0,
                    restul12: 0,
                    title: '',
                    name: ''

                }
                let actualA = {
                    restul: 0,
                    restul2: 0,
                    restul3: 0,
                    restul4: 0,
                    restul5: 0,
                    restul6: 0,
                    restul7: 0,
                    restul8: 0,
                    restul9: 0,
                    restul10: 0,
                    restul11: 0,
                    restul12: 0,
                    title: '',
                    name: ''

                }
                let dclD = {
                    restul: 0,
                    restul2: 0,
                    restul3: 0,
                    restul4: 0,
                    restul5: 0,
                    restul6: 0,
                    restul7: 0,
                    restul8: 0,
                    restul9: 0,
                    restul10: 0,
                    restul11: 0,
                    restul12: 0,
                    title: '',
                    name: ''

                }
                for (let i = 0; i < target.length; i++) {
                    let objT = target[i]
                    targetT.title = objT.title
                    targetT.name = '合计(数量)'
                    targetT.restul += parseInt(objT.m1.amount || 0)
                    targetT.restul2 += parseInt(objT.m2.amount || 0)
                    targetT.restul3 += parseInt(objT.m3.amount || 0)
                    targetT.restul4 += parseInt(objT.m4.amount || 0)
                    targetT.restul5 += parseInt(objT.m5.amount || 0)
                    targetT.restul6 += parseInt(objT.m6.amount || 0)
                    targetT.restul7 += parseInt(objT.m7.amount || 0)
                    targetT.restul8 += parseInt(objT.m8.amount || 0)
                    targetT.restul9 += parseInt(objT.m9.amount || 0)
                    targetT.restul10 += parseInt(objT.m10.amount || 0)
                    targetT.restul11 += parseInt(objT.m11.amount || 0)
                    targetT.restul12 += parseInt(objT.m12.amount || 0)
                }
                for (let i = 0; i < forecast.length; i++) {
                    let objF = forecast[i]
                    forecastF.title = objF.title
                    forecastF.name = '合计(数量)'
                    forecastF.restul += parseInt(objF.m1.amount || 0)
                    forecastF.restul2 += parseInt(objF.m2.amount || 0)
                    forecastF.restul3 += parseInt(objF.m3.amount || 0)
                    forecastF.restul4 += parseInt(objF.m4.amount || 0)
                    forecastF.restul5 += parseInt(objF.m5.amount || 0)
                    forecastF.restul6 += parseInt(objF.m6.amount || 0)
                    forecastF.restul7 += parseInt(objF.m7.amount || 0)
                    forecastF.restul8 += parseInt(objF.m8.amount || 0)
                    forecastF.restul9 += parseInt(objF.m9.amount || 0)
                    forecastF.restul10 += parseInt(objF.m10.amount || 0)
                    forecastF.restul11 += parseInt(objF.m11.amount || 0)
                    forecastF.restul12 += parseInt(objF.m12.amount || 0)
                }
                for (let i = 0; i < actual.length; i++) {
                    let objA = actual[i]
                    actualA.title = objA.title
                    actualA.name = '合计(数量)'
                    actualA.restul += parseInt(objA.m1.amount || 0)
                    actualA.restul2 += parseInt(objA.m2.amount || 0)
                    actualA.restul3 += parseInt(objA.m3.amount || 0)
                    actualA.restul4 += parseInt(objA.m4.amount || 0)
                    actualA.restul5 += parseInt(objA.m5.amount || 0)
                    actualA.restul6 += parseInt(objA.m6.amount || 0)
                    actualA.restul7 += parseInt(objA.m7.amount || 0)
                    actualA.restul8 += parseInt(objA.m8.amount || 0)
                    actualA.restul9 += parseInt(objA.m9.amount || 0)
                    actualA.restul10 += parseInt(objA.m10.amount || 0)
                    actualA.restul11 += parseInt(objA.m11.amount || 0)
                    actualA.restul12 += parseInt(objA.m12.amount || 0)
                }
                for (let i = 0; i < dcl.length; i++) {
                    let objD = dcl[i]
                    dclD.title = objD.title
                    dclD.name = '合计(数量)'
                    dclD.restul += this.fangfa3(parseInt(objD.m1.title.split('%')[0]))
                    dclD.restul2 += this.fangfa3(parseInt(objD.m2.title.split('%')[0]))
                    dclD.restul3 += this.fangfa3(parseInt(objD.m3.title.split('%')[0]))
                    dclD.restul4 += this.fangfa3(parseInt(objD.m4.title.split('%')[0]))
                    dclD.restul5 += this.fangfa3(parseInt(objD.m5.title.split('%')[0]))
                    dclD.restul6 += this.fangfa3(parseInt(objD.m6.title.split('%')[0]))
                    dclD.restul7 += this.fangfa3(parseInt(objD.m7.title.split('%')[0]))
                    dclD.restul8 += this.fangfa3(parseInt(objD.m8.title.split('%')[0]))
                    dclD.restul9 += this.fangfa3(parseInt(objD.m9.title.split('%')[0]))
                    dclD.restul10 += this.fangfa3(parseInt(objD.m10.title.split('%')[0]))
                    dclD.restul11 += this.fangfa3(parseInt(objD.m11.title.split('%')[0]))
                    dclD.restul12 += this.fangfa3(parseInt(objD.m12.title.split('%')[0]))
                }
                this.NewtableData = [targetT, forecastF, actualA, dclD]

                //console.log('11111',this.NewtableData)




            },

            panduan(array) {

                for (var i = 0; i < array.length; i++) {
                    //  用obj接收item.array里的对象
                    let obj = array[i]
                    //判断是否符合
                    //                    console.log("obj.start_date -》 " + obj.start_date)
                    //                    console.log("obj.time -》 " + this.time)
                    //                    console.log("obj.end_date -》 " + obj.end_date)
                    //                    console.log(obj.start_date<this.time && this.time <obj.end_date )

                    if (obj.start_date < this.time && this.time < obj.end_date) {
                        return false
                    }
                }
                return true
            }
        },

        computed: {


        },
        mounted() {

        },
        watch: {}
    }
</script>

<style lang="scss" module>
    .container {
        background: white;
        min-height: 100%;

    }
</style>
<style scoped>
    .people>>>.el-form-item__label {
        font-size: 16px;
        color: #000000;
    }

    .box {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .swiper-container {

        width: 93%;
        height: 102px;
        background-color: #fff;
        display: flex;

    }

    .swiper-wrapper {
        height: 100px;
        width: 100%;
    }

    .swiper-slide {
        width: 425px;
        margin-right: 20px;
        background-color: #fff;
        border: 1px solid #ededed;
    }

    .inputStyle {
        border-radius: 3px;
        height: 25px;
        border: 1px solid #ededed;
        width: 90%;
        text-align: center;
    }

    .box1>>>.el-tabs {
        height: 100%;
    }

    .box1>>>.el-tabs__content {
        height: calc(100% - 55px);
    }

    .box1>>>.el-tab-pane {
        height: 100%;
    }
</style>
<style>
    #div1 {
        display: none;
    }

    #div2 {
        display: none;
    }

    #div3 {
        display: none;
    }

    .headerStyleMy>div {
        font-size: 14px;
        /*color: #585757;*/
        font-weight: bold;
    }

    /*.el-input--prefix .el-input__inner{*/
    /*color:#FF9901;*/
    /*}*/
    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        background-color: #e6f1fc;
        color: #2b92fa;
    }
</style>


// WEBPACK FOOTER //
// src/pages/salesdata/home.vue